import { Injectable, OnDestroy } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { HttpBackend, HttpClient, HttpHeaders } from '@angular/common/http';
import {
  Observable,
  Subject,
  Subscription,
  catchError,
  filter,
  interval,
  of,
  throwError,
  lastValueFrom,
} from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import CryptoJS from 'crypto-js';
import { Location } from '@angular/common';
@Injectable({ providedIn: 'root' })
export class ServiceService implements OnDestroy {
  //Forgot Password
  private readonly forgotpassword = '/adminForgot/verifyEmail';
  private readonly VerifyOtp = '/adminForgot/verifyOtp';
  private readonly ResendOTP = '/adminForgot/resendOtp';
  private readonly reset = '/adminForgot/reset';

  // Change Management
  private readonly viewallchangemanagement = '/changeMgmt/viewByFilter';
  private readonly viewallchangemanagementbyid = '/changeMgmt/viewById';
  private readonly editallchangeManagement = '/changeMgmt/update';
  private readonly AddallchangeManagement = '/changeMgmt/createChangeMgmtForm';
  private readonly AddallbackupchangeManagement =
    '/changeMgmt/implementerStatus';
  private readonly addapproval1 = '/changeMgmt/approvalStatus';
  private readonly addapproval2 = '/changeMgmt/approvalStatus2';
  private readonly addapproval3 = '/changeMgmt/approvalStatus3';
  private readonly resubmissionhistoryrejectapi =
    '/changeMgmt/findChangeManagementApprovalHistory';
  private readonly resubmissionhistoryupdateapi =
    '/changeMgmt/findByChangeMangementUpdateHistory';
  private readonly implementationhistorygetallapi =
    '/changeMgmt/findChangeManagementImplementorHistory';
  private readonly formhistoryviewbyidapi = '/changeMgmt/updateHistoryGetById';

  //Asset Management
  private readonly assettrackerviewall = '/assetTrack/assetFilterSearch';
  private readonly assettrackeradd = '/assetTrack/addAsset';
  private readonly assettrackerupdate = '/assetTrack/update';
  private readonly assetttrackerbyid = '/assetTrack/getById';
  private readonly assettrackerstatus = '/assetTrack/makeActiveInactive';
  private readonly getallassetbyphysicalstatusapi =
    '/assetTrack/getAssetListByPhysicalStatus';
  private readonly assetreasignapi = '/assetTrack/assetEmployeeUpdate';
  private readonly getassethistorybyidapi =
    '/assetTrack/getAssetEmployeeAssignHistory';
  private readonly assetreviewerapi = '/assetTrack/riewAsserts';
  private readonly getallassetsbyorganizationapi =
    '/assetTrack/findAssetsByOrganizationId';
  private readonly getallpendingassetapi =
    '/assetTrack/getAssetApprovalPending';
  private readonly approvependingassetapi = '/assetTrack/approveAsserts';
  private readonly getallassetbytypeidapi = '/assetTrack/findAllAssetsByTypeId';
  private readonly getassetupdatehistorybyidapi =
    '/assetTrack/findAllAssetUpdateHistoryByAssetId';
  private readonly getassetupdatehistorybyhistoryidapi =
    '/assetTrack/findByAssetHistoryId';
  private readonly getallassereviewedhistoryapi =
    '/assetTrack/findAllAssetReviewHistory';
  private readonly getallasseapprovedhistoryapi =
    '/assetTrack/findAllAssetApprovalHistory';
  private readonly getbyidassereviewedhistoryapi =
    '/assetTrack/findAllAssetReviewHistoryByAssetId';
  private readonly getbyidasseapprovedhistoryapi =
    '/assetTrack/findAllAssetApprovalHistoryByAssetId';
  private readonly getbyidassetAIhistoryapi =
    '/assetTrack/findAssetStatusHistoryByAssetId';
  private readonly fetchaccetdetailsbyemailapi =
    '/assetTrack/findByEmailAddress';
  private readonly getassetforusersorunassigned =
    '/assetTrack/viewByAssetTypeWithEmailAddress';

  private readonly fetchhostnameapi =
    '/assetTrack/findAssetByAssetTypeIdAndEmailAddress';

  //Asset Service History
  private readonly getallservicehistoryapi = '/serviceHistory/viewByFilter';
  private readonly serviceassetcreationapi =
    '/serviceHistory/assetServiceCreation';
  private readonly serviceassetdailyupdateapi =
    '/serviceHistory/assetServiceCommentUpdate';
  private readonly serviceassetclosureapi =
    '/serviceHistory/updateAssetService';
  private readonly viewservicebillapi =
    '/serviceHistory/viewAssetServiceClosureDocument';
  private readonly serviceassethistoryapi =
    '/serviceHistory/findAssetServiceCommentHistory';

  //Patch Management
  private readonly Patchviewall = '/patch/patchSearchFilter ';
  private readonly Addpatch = '/patch/addThePatch';
  private readonly patchviewbyid = '/patch/getById';
  private readonly UpdatePatch = '/patch/updateThePatch';
  private readonly Approvetestdevice = '/patch/approvalStatusForTesting';
  private readonly Updatefortestdevice =
    '/patch/patchAppliedOnTestDeviceUpdate';
  private readonly PatchTestImageView = '/patch/patchTestimageView';
  private readonly Approveclientdevice =
    '/patch/approvalStatusForApplyPatchToClientDevices';
  private readonly Updateforclientdevice =
    '/patch/patchAppliedOnClientDeviceUpdate';
  private readonly getpatchuploadefilebyidapi = '/patch/viewPatchImage';
  private readonly gettestupdatehistoryimageapi = '/patch/viewTestUpdatePatch';
  private readonly getpatchupdatehistoryapi =
    '/patch/findPatchManagementApprovalList';
  private readonly getpatchmodifiedhistoryapi =
    '/patch/getPatchUpdateHistoryListByPatchId';
  private readonly getpatchevidencehistoryapi =
    '/patch/findAllTestUpdateHistoryByPatchId';
  private readonly getpatchmodifiedfilehistoryapi =
    '/patch/getPatchUpdateHistoryImage';
  private readonly productiondevicerequestapi =
    '/patch/patchAssetClientRequest';
  private readonly editproductiondevicerequestapi = '/patch/patchRequestUpdate';
  private readonly getrequesteddevicebyidapi =
    '/patch/FindAllClientApprovalAssets';
  private readonly getrequesteddevicebystatusapi =
    '/patch/findClientApprovalAssetByPatchId';
  private readonly getrequesteddevicehistoryapi =
    '/patch/findAllClientRequestByPatchId';
  private readonly getclientupdatehistoryapi =
    '/patch/findAllClientUpdateHistoryByPatchId';
  private readonly getclientupdatehistorypdfapi =
    '/patch/viewClientUpdateImage';
  private readonly getclientupdatepdfapi = '/patch/patchClientimageView';
  private readonly getbackupdocumentapi = '/patch/viewBackUpDocumentImage';
  private readonly patchfinalapprovalapi = '/patch/patchFinalApproval';
  private readonly viewpatchistorybackupdocumenthapi =
    '/patch/viewHistoryBackUpDocument';
  private readonly getfinalapprovalhistoryapi =
    '/patch/getPatchFinalApprovalHistoryByPatchId';
  private readonly getrequesteddeviceshistoryapi =
    '/patch/findAllClientRequestedDeviceHostNames';
  private readonly updaterequesteddeviceapi =
    '/patch/findAllRequestDeviceAssets';

  //Incident Management
  private readonly Incidentreportgetall =
    '/incidentReport/incidentManagementFilter';
  private readonly Incidentreportgetbyid = '/incidentReport/getById';
  private readonly incidentreportadd = '/incidentReport/createIncidentReport';
  private readonly incidenreportUpdate = '/incidentReport/updateIncidentReport';
  private readonly IncidentImageView = '/incidentReport/imageView';
  private readonly getallincidentmodifiedhistoryapi =
    '/incidentReport/GetAllIncidentManagementHistory';
  private readonly getincidentmodifiedhistorybyidapi =
    '/incidentReport/getIncidentManagementHistoryById';
  private readonly viewincidentmodifiedhistoryimageapi =
    '/incidentReport/incidentHistoryImageView';
  private readonly closureformsubmitapi = '/incidentReport/closureSubmittion';
  private readonly incidentfinalapprovalsubmitapi =
    '/incidentReport/incidentApproval';
  private readonly getallfinalapprovalhistoryapi =
    '/incidentReport/getIncidentApprovalHistoryByIncidentId';
  private readonly viewincidentclosuredocumentapi =
    '/incidentReport/viewClosureDocument';
  private readonly getallincidentclosurehistoryapi =
    '/incidentReport/getClosureHistoryByIncidentId';
  private readonly viewincidentclosuredocumenthistoryapi =
    '/incidentReport/viewClosureHistoryDocument';

  //Vendor Compliance Report
  private readonly Compliancereportviewall =
    '/compliancereport/vendorsearchFilter';
  private readonly Createreport = '/compliancereport/vendorComplianceCreation';
  private readonly UpdateReport = '/compliancereport/updateVendorCompliance';
  private readonly createreportbyid = '/compliancereport/viewByid';
  private readonly vendorcompliancedocument =
    '/compliancereport/viewVendorComplianceDocument';
  private readonly vendorcmpliancedocpassword =
    '/compliancereport/vendorCompliancePasswordVerification';

  //Tyche Compliance Report
  private readonly TychecomplianceViewall = '/tycheCompliance/viewByFilter';
  private readonly AddTycheCompliance =
    '/tycheCompliance/complianceDocumentCreation';
  private readonly UpdateTycheCompliance =
    '/tycheCompliance/complianceDocumentUpdate';
  private readonly Tychecompliancebyid = '/tycheCompliance/getdatabyid';
  private readonly Tychecompliancedocument = '/tycheCompliance/viewdocuments';
  private readonly Tychecompliancedocpassword =
    '/tycheCompliance/filePasswordVerification';

  //Service Ticket
  private readonly updateticket = '/serviceTicket/serviceTicketStatusUpdate';
  private readonly Serviceticketviewall =
    '/serviceTicket/serviceSearchFilterByEmployee';
  private readonly rasiseserviceticket = '/serviceTicket/serviceTicketCreation';
  private readonly Ticketbyid = '/serviceTicket/getById';
  private readonly Viewserviceimage = '/serviceTicket/viewServiceTicketImage';
  private readonly Viewserviceresponseimageapi =
    '/serviceTicket/viewServiceTicketResponseImage';
  private readonly Viewservicehistoryresponseimageapi =
    '/serviceTicket/viewTicketResponseHistoryImage';
  private readonly Viewservicetickethistoryapi =
    '/serviceTicket/findTicketResponseHistoryByServiceId';
  private readonly itservicedailyupdateapi =
    '/serviceTicket/serviceTicketDailyCommentUpdate';
  private readonly itservicecommenthistoryapi =
    '/serviceTicket/findByServiceDailyCommentHistory';

  //Audit Logs
  private readonly moduleslistapi = '/modules/viewByFilter';
  private readonly getauditlogsapi = '/searchFilter/auditLogFilter';

  //Report Generation
  private readonly repotrsviewallapi = '/report/ViewByFilter';
  private readonly repotrstatuscheck = '/report/checkReportStatus';
  private readonly reportgeneration = '/report/generate';
  private readonly reportdownload = '/report/viewExcel';

  //User management
  //Admin
  private readonly loginpath = '/admin/login';
  private readonly logoutAPI = '/admin/logout';
  private readonly Addadmindata = '/admin/add';
  private readonly changeadminstatus = '/admin/adminStatus';
  private readonly editadmindata = '/admin/update';
  private readonly viewadminbyid = '/admin/getById';
  private readonly adminunblock = '/admin/unBlockAccount';
  private readonly adminprofileimgviewapi = '/admin/profileImageView';
  private readonly fetchdetailsbyemailapi = '/admin/getByEmailAddress';
  private readonly getallemployeeapi = '/admin/getAllEmployees';
  private readonly getcaptchaapi = '/admin/captchaCreation/';
  private readonly getpermissionsapi =
    '/admin/getEmployeePermissionsByEmailAddress';
  private readonly checkloginstatusapi = '/admin/getLoginHistoryById';
  private readonly changepsw = '/admin/changePassword';
  private readonly getloginhistoryapi = '/admin/getEmployeeLoginHistory';
  private readonly viewalladmin = '/searchFilter/adminFilter';

  //Employee
  private readonly employeeststus = '/employee/makeActiveInactive';
  private readonly addemployee = '/employee/createEmployee';
  private readonly updateemployee = '/employee/updateEmployee';
  private readonly Employeebyid = '/employee/getById';
  private readonly unblockemp = '/employee/unBlockAccount';
  private readonly employeprofileimgviewapi = '/employee/employeeProfileView';
  private readonly employeeviewall = '/searchFilter/employeeFilter';

  //Permission
  private readonly AddPermission = '/permission/addPermission';
  private readonly PermissionStatus = '/permission/makeActiveInactive';
  private readonly ActivePermission = '/permission/getAllActive';
  private readonly ViewallPermission = '/searchFilter/permissionFilter';

  //SUB-Permission
  private readonly AddSubPermission = '/subPermission/addSubPermission';
  private readonly SUbPermissionstatus = '/subPermission/makeActiveInactive';
  private readonly VieallSubpermission =
    '/searchFilter/subPermissionFilterSearch';

  //Role Action
  private readonly RoleActionadd = '/roleAction/addroleaction';
  private readonly Roleactionstatus = '/roleAction/updateStatus';
  private readonly roleactionfilterapi = '/roleAction/viewByFilter';
  private readonly copyperadmin = '/roleAction/copyPermisionforadmin';
  private readonly copyperemp = '/roleAction/copyPermisionforemployee';

  //Main Master
  //Assets Type
  private readonly Addassets = '/assetType/add';
  private readonly updateassets = '/assetType/update';
  private readonly assetsbyid = '/assetType/getById';
  private readonly assetsactiveinactive = '/assetType/makeActiveInactive';
  private readonly getassetswithoutpheripheralapi =
    '/assetType/getAllAssetTypeWithOutCpu';
  private readonly assetsviewall = '/searchFilter/assetTypeFilter';

  //Assets Brand
  private readonly assetsmakeradd = '/assetMaker/add';
  private readonly assetmakeredit = '/assetMaker/update';
  private readonly assetsmakerbyid = '/assetMaker/getById';
  private readonly assetsmakerstatus = '/assetMaker/makeActiveInactive';
  private readonly getassetbrandbytypeidapi = '/assetMaker/findByAssetType';
  private readonly assetsmakerviewall = '/searchFilter/assetBrandFilter';

  //Asset Model
  private readonly Addassetmodel = '/assetModel/create';
  private readonly UpdateAssetmodel = '/assetModel/edit';
  private readonly statusassetmodel = '/assetModel/editStatus';
  private readonly Assetmodelbyid = '/assetModel/getAssetModel';
  private readonly getmodelapi = '/assetModel/findByAssetTypeAndAssetBrand';
  private readonly Assetmodelgetall = '/searchFilter/assetModelFilterSearch';

  //Vendor
  private readonly vendoradd = '/vendor/add';
  private readonly Updateventor = '/vendor/updateVendor';
  private readonly ventorbyid = '/vendor/getByVendorId';
  private readonly ventorstatus = '/vendor/makeActiveInactive';
  private readonly vendorgetbystatusapi = '/vendor/findByVendorLevel';
  private readonly vendorviewall = '/searchFilter/vendorSearch';

  //Incident Alert
  private readonly escalationcreationapi = '/incidentReport/esclationCreation';
  private readonly incidentalertupdate = '/incidentReport/esclationUpdation';
  private readonly getallescalationapi = '/incidentReport/viewByFilter';
  private readonly getescalationdetailsbyidapi =
    '/incidentReport/getByEsclationId';
  private readonly getallemailloghistoryapi =
    '/incidentReport/mailTriggerHistoryFilter';

  //Processor
  private readonly AddProcessor = '/processor/add';
  private readonly UpdateProcessor = '/processor/edit';
  private readonly Processorbyid = '/processor/viewbyid';
  private readonly ProcessorStatus = '/processor/editStatus';
  private readonly Processorviewall = '/searchFilter/processorFilter';

  //Category for Tyche compliance
  private readonly Tychecategoryadd = '/complianceCategory/add';
  private readonly Tychecategorybyid = '/complianceCategory/getCategoryById';
  private readonly Tychecategoryupdate = '/complianceCategory/update';
  private readonly Tychecategorystatus = '/complianceCategory/updateStatus';
  private readonly tychecategorygetall = '/searchFilter/certificateTypeSearch ';

  //Company
  private readonly AddCompany = '/company/add';
  private readonly Updatecompany = '/company/update';
  private readonly organizationgetbyidapi = '/company/getById';
  private readonly companystatus = '/company/makeActiveInactive';
  private readonly Companyviewall = '/searchFilter/organizationSearchFilter';
  private readonly CompanyGetByPermission = '/company/viewByStatusAndAccess';

  //Department
  private readonly adddepartment = '/department/add';
  private readonly Updatedepartment = '/department/updateById';
  private readonly departmentbyid = '/department/getById';
  private readonly departmentactiveinactive = '/department/makeActiveInactive';
  private readonly departmetviewall = '/searchFilter/departmentSearchFilter';

  //Desigination
  private readonly adddesigination = '/designation/add';
  private readonly desiginationbyid = '/designation/getById';
  private readonly Updatedesigination = '/designation/updateById';
  private readonly desiginationstatus = '/designation/makeActiveInactive';
  private readonly DesigibationViewall =
    '/searchFilter/designationSearchFilter';

  // Training Category
  private readonly addtrainingcategory =
    '/trainingCategory/trainingCategoryCreate';
  private readonly getalltrainingcategory =
    '/searchFilter/traingCategorySearchFilter';
  private readonly trainingcategorystatus =
    '/trainingCategory/updateTrainingCategoryStatus';
  private readonly edittrainingcategory =
    '/trainingCategory/trainingCategoryUpdate';
  private readonly gettrainingcategorybyid =
    '/trainingCategory/trainingCategoryFindById';

  // Training Name
  private readonly addtrainingname = '/trainingName/trainingNameCreation';
  private readonly getalltrainingname = '/searchFilter/traingNameSearchFilter';
  private readonly trainingnamestatus =
    '/trainingName/trainingNameStatusUpdate';
  private readonly edittrainingname = '/trainingName/trainingNameUpdate';
  private readonly gettrainingnamebyid = '/trainingName/trainingNameGetById';

  // Training Creation
  private readonly addtraining = '/trainingManagement/trainingCreation';
  private readonly getalltrainings = '/trainingManagement/trainingSearchFilter';
  private readonly gettrainingbyid = '/trainingManagement/trainingFindById';
  private readonly getevidenceimage =
    '/trainingManagement/trainingEvidenceImageView';
  private readonly getattendanceimage =
    '/trainingManagement/attendanceSheetImageView';
  private readonly gettrainingimage =
    '/trainingManagement/trainingMaterialImageView';
  private readonly edittraining = '/trainingManagement/trainingUpdate';
  private readonly trainingstatusupdate =
    '/trainingManagement/updateTrainingStatus';
  private readonly traininghistorybyid =
    '/trainingManagement/updateHistoryFindByTrainingId';
  private readonly gettraininghistorybyid =
    '/trainingManagement/findByTrainingManagementHistoryId';
  private readonly getevidencehistoryimage =
    '/trainingManagement/updateHistoryTrainingEvidenceImageView';
  private readonly getattendancehistoryimage =
    '/trainingManagement/historyAttendanceSheetImageView ';
  private readonly gettraininghistoryimage =
    '/trainingManagement/historyTrainingMaterialImageView';
  private readonly acknowledgetraining =
    '/trainingManagement/trainingAcknowledgeByEmployee';
  private readonly getalltrainingsdropdown =
    '/trainingManagement/findAllTraining';

  // Assessment
  private readonly addassessment = '/api/assessment/create';
  private readonly getallassessment = '/api/assessment/viewByFilter';
  private readonly editassessment = '/api/assessment/update';
  private readonly cancelassessment = '/api/assessment/cancel';
  private readonly publishassessment = '/api/assessment/publish';
  private readonly generatequestions = '/api/assessment-questions/generate';
  private readonly getallquestions = '/api/assessment-questions/viewByFilter';
  private readonly deletequestions =
    '/api/assessment-questions/deleteSelectedQuestions';
  private readonly reviewquestion = '/api/assessment/reviewQuestions';
  private readonly assessmenthistory =
    '/api/assessment/viewUpdateHistoryByAssessmentId';
  private readonly viewallassessment =
    '/api/assessment-attendance/viewByFilter';
  private readonly viewconductlog =
    '/api/assessment-attendance/viewMisConductLog';
  private readonly viewconductimage =
    '/api/assessment-attendance/viewMisConductEvidence';
  private readonly publishresult =
    '/api/assessment-attendance/reviewAndPublishResultByAttendanceId';
  private readonly publishall = '/api/assessment-attendance/publishAllResults';
  private readonly reassign = '/api/assessment-attendance/reassignAssessment';
  private readonly revokesession = '/api/assessment-attendance/revokeSession';
  private readonly getcertificate =
    '/api/assessment-attendance/viewCertificate';
  private readonly employeeassessmenthistory =
    '/api/assessment-attendance/viewAttendeePreviousRecords';

  // Test module
  private readonly getalltest =
    '/api/assessment-attendance/getAllByEmployeeEmail';
  private readonly getquestions = '/api/assessment-attendance/startAssessment';
  private readonly submitanswer =
    '/api/assessment-attendance/submitSingleAnswer';
  private readonly quicksubmit = '/api/assessment-attendance/suspendSession';
  private readonly addattendeeimage =
    '/api/assessment-attendance/addAttendeeImage';
  private readonly getattendeeimage =
    '/api/assessment-attendance/viewAttendeeImage';

  // Assessment Topics
  private readonly addtopic = '/api/assessment-topics/add';
  private readonly edittopic = '/api/assessment-topics/update';
  private readonly topicstatusupdate = '/api/assessment-topics/updateStatus';
  private readonly getalltopics = '/api/assessment-topics/viewByFilters';

  // Certificate Content
  private readonly addcertificatecontent = '/api/certifcate-content/add';
  private readonly editcertificatecontent = '/api/certifcate-content/update';
  private readonly contentstatusupdate = '/api/certifcate-content/updateStatus';
  private readonly getallcontent = '/api/certifcate-content/viewByFilter';

  // Certificate Signers
  private readonly addcertificatesigners = '/api/certificate-signer/add';
  private readonly editcertificatesigners = '/api/certificate-signer/update';
  private readonly certificatesignersstatus =
    '/api/certificate-signer/updateStatus';
  private readonly getallcertificatesigners =
    '/api/certificate-signer/viewByFilter';
  private readonly viewcertificatesignersimage =
    '/api/certificate-signer/viewSign';

  // Board Resolution
  private readonly createboard = '/broadResolution/broadResolutionCreation';
  private readonly editboard = '/broadResolution/broadResolutionUpdate';
  private readonly boardgetbyid = '/broadResolution/broadResolutionFindById';
  private readonly getboard = '/broadResolution/broadResolutionSearchFilter';
  private readonly viewimage = '/broadResolution/BoardResolution/';
  private readonly passwordverimg =
    '/broadResolution/documentPasswordVerification';
  private readonly updatestatusresolution =
    '/broadResolution/broadResolutionStatusUpdate';
  private readonly resolutionhistory =
    '/broadResolution/findUpdateHistoryByBroadResolutionId';

  // exam questions
  private readonly assessmentquestions =
    '/api/assessment-attendance/getIndividualReport';

  // Policy & Procedure
  private readonly createpolicyprocedure =
    '/policyProcedure/policyProcedureCreation';
  private readonly updatepolicyprocedure =
    '/policyProcedure/policyProcedureUpdate';
  private readonly viewpolicyprocedure =
    '/policyProcedure/policyProcedureSearchFilter';
  private readonly policybyid = '/policyProcedure/policyProcedureFindById';
  private readonly historypolicyprocedure =
    '/policyProcedure/historyFindByPolicyId';
  private readonly reviewhistory =
    '/policyProcedure/findReviewHistoryByPolicyId';
  private readonly approvalhistory =
    '/policyProcedure/findApprovalHistoryByPolicyId';
  private readonly policyhistorybyid =
    '/policyProcedure/policyProcedureHistoryFindById';
  private readonly reviewapi = '/policyProcedure/policyProcedureReview';
  private readonly genratepdf = '/policyProcedure/PolicyProcedurePdfGeneration';
  private readonly pdfview = '/policyProcedure/PolicyProcedurePdfView';
  private readonly pdfdocument = '/policyProcedure/PolicyProcedureFinalPdfView';

  private readonly actiondates = '/api/assessment/viewActionHistory';
  private readonly editanswers = '/api/assessment-questions/reselectAnswer';

  
    //SSL Management
    private readonly addsslapi = '/api/ssl-management/add';
    private readonly editsslapi = '/api/ssl-management/update';
    private readonly getallsslapi = '/api/ssl-management/viewByFilter';
    private readonly sslgetbyidapi = '/api/ssl-management/viewById';
    private readonly sslpassverifyapi = '/api/ssl-management/verifyPasswordForSSL';
    private readonly viewssldocumentbyidapi = '/api/ssl-management/viewFile';
    private readonly viewsslhistorybyidapi = '/api/ssl-management/viewUpdateHistoryBySslId';
    // private readonly viewsslhistorybyidapi='/api/ssl-management/viewUpdateHistoryByHistoryId';
    private readonly viewsslhistorydocumentbyidapi = '/api/ssl-management/viewUpdateHistoryFile';
    private readonly viewsslhistorybyfilteridapi = '/api/ssl-management/viewUpdateHistoryByFilter';
    private readonly changepasswordrequestforSSL ='/api/ssl-management/changePasswordRequest';
    private readonly sendotpforSSL ='/api/ssl-management/sendOtp';
    private readonly verifyotpforSSl ='/api/ssl-management/verifyOtp';
    private readonly resentpassword ='/api/ssl-management/resetPassword';
    private readonly viewlinkSSL ='/api/ssl-management/viewByLinkId'

    //Email License Management
    private readonly addemaillicenseapi = '/emailLicenseManagement/emailLicenseCreation';
    private readonly editemaillicenseapi = '/emailLicenseManagement/emailLicenseUpdate';
    private readonly getallemaillicenseapi = '/emailLicenseManagement/emailLicenseSearchFilter';
    private readonly emaillicensegetbyidapi = '/emailLicenseManagement/findById';
    private readonly emaillicensehistorybyidapi = '/emailLicenseManagement/updateHistoryByLicenseId';

    //Employee Policy
    private readonly addemployeepolicyapi = "/employeePolicy/employeePolicyCreation";
    private readonly employeepolicygetbyidapi = "/employeePolicy/employeePolicyFindById";
    private readonly editemployeepolicyapi = "/employeePolicy/employeePolicyUpdate";
    private readonly getallemployeepolicyapi = "/employeePolicy/employeePolicySearchFilter";
    private readonly employeepolicyhistorybyidapi = "/employeePolicy/findUpdateHistoryByPolicyId";
    private readonly employeepolicypassverifyapi = "/employeePolicy/employeePolicyDocumentPasswordVerify";
    private readonly employeepolicydocumentviewapi = "/employeePolicy/employeePolicyDocumentView";
    private readonly employeepolicyacknowledgementapi = "/employeePolicy/employeePolicyAcknowledge";
    private readonly viewbylinkidforemppolicy ='/employeePolicy/viewByLinkId';
    private readonly changepasswordrequestforemppolicy  ='/employeePolicy/changePasswordRequest';
    private readonly sendotpforemppolicy ='/employeePolicy/sendOtp';
    private readonly verifyotpforemppolicy ='/employeePolicy/verifyOtp';
    private readonly resetpassword ='/employeePolicy/resetPassword';

 

  // Mom
  private readonly addfirstform = '/api/mom/add';
  private readonly addsecondform = '/api/mom/addAgenda';
  private readonly addthirdform = '/api/mom/addDiscussions';
  private readonly getallmom = '/api/mom/viewByFilters';
  private readonly getmomemployees = '/api/mom/viewAttendees';
  private readonly getmombyid = '/api/mom/viewById';
  private readonly updatemom = '/api/mom/update';
  private readonly ackmom = '/api/mom/acknowledgement';
  private readonly approvemom = '/api/mom/approval';
  private readonly viewmomhistory = '/api/mom/viewUpdateHistory';
  private readonly viewmomhistorybyid = '/api/mom/viewUpdateHistoryByHistoryId';
  private readonly momactiondates = '/api/mom/viewActions';

  // Main master framework

  private readonly frameworkadd =
    '/policyProcedureFramework/policyProcedureFrameworkCreation';
  private readonly frameworkedit =
    '/policyProcedureFramework/policyProcedureFrameworkUpdate';
  private readonly framwworkfindbyid =
    '/policyProcedureFramework/policyProcedureFrameworkFindById';
  private readonly frameworkgetall =
    '/searchFilter/policyProcedureFrameworkSearchFilter';
  private readonly frameworkstaupdate =
    '/policyProcedureFramework/policyFrameworkStausUpdate';
  private readonly framworkactivestatus =
    '/policyProcedureFramework/policyFrameworkStausUpdate';

    // Agreementcontract

    private readonly addagreentcont = '/api/agreement/add';
    private readonly editagreemtcont = '/api/agreement/update';
    private readonly getallagreement = '/api/agreement/viewByFilters';
    private readonly getbyidagreement = '/api/agreement/viewById';
    private readonly agrementhistoryview = '/api/agreement/viewHistoryByAgreementId';
    private readonly passwordvirify = '/api/agreement/verifyPasswordForAgreement';
    private readonly viewdocument = '/api/agreement/viewFile';
    private readonly historypassword = '/api/agreement/verifyPasswordForAgreementHistory';
    private readonly historyfileverify = '/api/agreement/viewHistoryFile';
    private readonly updaterequestpassword = '/api/agreement/changePasswordRequest';
    private readonly sendotpforagreement = '/api/agreement/sendOtp';
    private readonly verifyotpforagreement ='/api/agreement/verifyOtp';
    private readonly resendpasswordforagreement ='/api/agreement/resetPassword';
    private readonly linkbyid ='/api/agreement/viewByLinkId'

 

  // Control Referene
  private readonly addreference = '/api/control-reference/add';
  private readonly editreference = '/api/control-reference/update';
  private readonly referencestatus = '/api/control-reference/updatedStatus';
  private readonly getallreference = '/api/control-reference/viewByFilter';

  // Audit Result
  private readonly addauditresult = '/api/audit-result/create';
  private readonly editauditresult = '/api/audit-result/update';
  private readonly addauditcontrol = '/api/audit-result/control/add';
  private readonly getauditresult = '/api/audit-result/viewByFilters';
  private readonly getemployeebydepartment = '/admin/getAllEmployeesByOrganizationAndDepartment';
  private readonly getauditcontrol = '/api/audit-result/control/viewByFilter';
  private readonly editauditcontrol = '/api/audit-result/control/update';
  private readonly addcorrective = '/api/audit-result/control/corrective-action/add';
  private readonly editcorrective = '/api/audit-result/control/corrective-action/update';
  private readonly auditreview = '/api/audit-result/control/reviewerAction';
  private readonly auditapprove = '/api/audit-result/control/approverAction';
  private readonly getcorrectivedatas = '/api/audit-result/control/corrective-action/viewByControlId';
  private readonly viewsupportdoc = '/api/audit-result/control/corrective-action/viewSupportDoc';
  private readonly viewsupportdochistory = '/api/audit-result/control/corrective-action/viewHistorySupportDoc';
  private readonly viewauditcontroldoc = '/api/audit-result/control/viewEvidence';
  private readonly viewauditcontrolhistorydoc = '/api/audit-result/control/viewHistoryEvidence';
  private readonly viewauditresulthistory = '/api/audit-result/viewHistoryByFilter';
  private readonly viewauditcontrolactions = '/api/audit-result/control/viewActions';
  private readonly viewauditcontrolhistory = '/api/audit-result/control/viewHistoryByFilter';
  private readonly viewcorrectivehistory = '/api/audit-result/control/corrective-action/viewByCorrectiveActionId'

     // Mainmaster Equipment creation

    private readonly equipmentcreation = '/equipments/equipmentsCreation';
    private readonly equipmentupdate = '/equipments/equipmentsUpdate';
    private readonly equipmentviewall = '/searchFilter/equipmentSearchFilter';
    private readonly equipmentupdatestatus = '/equipments/equipmentStatusUpdate';
    private readonly equipmentgetbuid = '/equipments/equipmentFindById'

    
     // Equipment AMCs

    private readonly AMCscreation = '/equipmentAmcs/equipmentAmcsCreation';
    private readonly AMCsupdate = '/equipmentAmcs/equipmentAmcsUpdate';
    private readonly AMCsviewall = '/equipmentAmcs/searchFilter';
    private readonly AMCsfindbyid = '/equipmentAmcs/equipmentAMCsFindById';
    private readonly AMCsviewdocument = '/equipmentAmcs/reportView';
    private readonly AMCsviewreport = '/equipmentAmcs/reportView';
    private readonly historydocview = '/equipmentAmcs/historyReportView';
    private readonly historyviewAMCs = '/equipmentAmcs/historyFindByEquipmentId';
    private readonly historyfindbuid = '/equipmentAmcs/historyFindById'


    // Tyche-complaines update password
    private readonly viewbylinkidforTychecom ='/tycheCompliance/viewByLinkId';
    private readonly sendrequestfortychecom ='/tycheCompliance/changePasswordRequest'
    private readonly sendotpfortychecom ='/tycheCompliance/sendOtp';
    private readonly verifyotpfortychecom ='/tycheCompliance/verifyOtp';
    private readonly resetpasswordfortychecom ='/tycheCompliance/resetPassword';

    // Vendor compalaines update password

    private readonly viewbylinkidforvendor = '/compliancereport/viewByLinkId';
    private readonly sendrequestforvendor ='/compliancereport/changePasswordRequest';
    private readonly sendotpforvendor ='/compliancereport/sendOtp';
    private readonly verifyotpforvendor ='/compliancereport/verifyOtp';
    private readonly resetpasswordforvendor ='/compliancereport/resetPassword';

    // Board resolution update password 

    private readonly viewbylinkidforboard ='/broadResolution/viewByLinkId';
    private readonly sendrequestforboard ='/broadResolution/changePasswordRequest';
    private readonly sendotpforboard = '/broadResolution/sendOtp';
    private readonly verifyotpforboard ='/broadResolution/verifyOtp';
    private readonly resetpasswordforboard ='/broadResolution/resetPassword'
    
 




    
  //Base Path
  // private readonly basePath = 'http://167.71.235.104:8080';
  private readonly basePath = 'https://staging-itcmsapi.tychepayment.com'; // UAT path
  // private readonly basePath = 'https://itcmsapi.tychepayment.com';  //Production path

//   private readonly generalURL = (bURL: string) => {
//     return (endPoint: any) => {
//       return `${bURL}${endPoint}`;
//     };
//   };

//   private readonly adminURL = this.generalURL(this.basePath);

  private timeoutInMinutes: number = 10; //Default timeout duration in minutes
  private eventListeners: { event: string; handler: () => void }[] = [];
  private readonly secretKey = 'P4uUv7rS0oTh3qW9zYm2BnIcK8lOa1jJ';
  private routerEventsSubscription!: Subscription;
  private listenersInitialized: boolean = false;
  private navigationSubscription!: Subscription;
  private statusCheckInterval!: Subscription;
  private isTimerActive: boolean = false;
  public lastAction: number = Date.now();
  public isLoggedInFlag: boolean = false;
  public timeLeftSeconds: any;
  public timer: any;
  loginError = new Subject();
  skiploader: HttpClient;
  loginhistoryid: any;
  token = sessionStorage.getItem('token');
  headers = new HttpHeaders({
    'Content-Type': 'application/json',
    'Access-Control-Allow-Origin': '*',
    X_ACCESS_TOKEN: `Bearer ${this.token ? sessionStorage.getItem('token') || '' : null}`,
  });
  headersMultipart = new HttpHeaders({
    'Access-Control-Allow-Origin': '*',
    X_ACCESS_TOKEN: `Bearer ${this.token ? sessionStorage.getItem('token') || '' : null}`,
  });
  options = { headers: this.headers };
  optionsMultipart = { headers: this.headersMultipart };

  passwordheaders = new HttpHeaders({ 'Content-Type': 'application/json', 'Access-Control-Allow-Origin': '*',
    X_ACCESS_TOKEN: `Bearer ${"eyJhbGciOiJIUzI1NiJ9.eyJVU0VSX05BTUUiOiJyYWplc2hrYW5uYS5tQGJhYnVqaXZlbnR1cmVzLmluIiwic3ViIjoicmFqZXNoa2FubmEubUBiYWJ1aml2ZW50dXJlcy5pbiIsImlhdCI6MTc3MTU3MzM2OSwiZXhwIjo5NjYwNzU3MzY5fQ.Ci1Dzp-_cpZOFqdiyIipy_7nsel3bBj5ijfUxkxlIBA"}` })
    Passwordtoken = { headers: this.passwordheaders };

  // constructor(
  //   private http: HttpClient,
  //   private backend: HttpBackend,
  //   private router: Router,
  //   private matdialog: MatDialog,
  //   private toast: ToastrService,
  //   private location: Location,
  // ) {
  //   this.skiploader = new HttpClient(backend);
  //   this.initializeHeaders();

  //   const isLoggedIn = sessionStorage.getItem('isloggedIn') === 'true';
  //   const lastAction = sessionStorage.getItem('lastAction'); 
  //   const timeoutState = localStorage.getItem('timeoutState');

  //   if (timeoutState === 'true') {
  //     this.router.navigate(['/timeout'], { replaceUrl: true });
  //     return;
  //   }
  //   if (isLoggedIn && lastAction) {
  //     this.isLoggedInFlag = true;
  //     this.lastAction = parseInt(lastAction, 10);
  //     const timeSinceLastAction = Date.now() - this.lastAction;
  //     if (timeSinceLastAction > this.timeoutInMinutes * 60000) {
  //       this.router.navigate(['/timeout'], { replaceUrl: true });
  //     } else {
  //       const encryptedData = sessionStorage.getItem('data');
  //       if (encryptedData) {
  //         try {
  //           const decryptedData: any = this.decryptData(encryptedData);
  //           const ogdata: any = JSON.parse(decryptedData);
  //           this.loginhistoryid = ogdata?.loginhistoryid;
  //           this.initListener();
  //           this.initTimer();
  //           this.startStatusCheckInterval();
  //         } catch (e) {
  //           console.error('Error decrypting data:', e);
  //           this.router.navigate(['/login-page'], { replaceUrl: true });
  //         }
  //       }
  //     }
  //   } else {
  //     this.lastAction = Date.now();
  //   }
  //   this.initRouterListener();
  // }
    constructor(private http: HttpClient, private backend: HttpBackend, private router: Router, private matdialog: MatDialog, private toast: ToastrService, private location: Location) {


  this.skiploader = new HttpClient(backend);
  this.initializeHeaders();

  const currentUrl = window.location.href;

  // 🔥 Skip login/session validation for reset password flow
  if (currentUrl.includes('PasswordChangeRequest')) {
    return;
  }

  // ===== EXISTING LOGIN LOGIC BELOW =====

  const isLoggedIn = sessionStorage.getItem('isloggedIn') === 'true';
  const lastAction = sessionStorage.getItem('lastAction');
  const timeoutState = localStorage.getItem('timeoutState');
  
        if (timeoutState === 'true') {
            this.router.navigate(['/timeout'], { replaceUrl: true });
            return;
        }

  if (isLoggedIn && lastAction) {

    this.isLoggedInFlag = true;
    this.lastAction = parseInt(lastAction, 10);
    const timeSinceLastAction = Date.now() - this.lastAction;

    if (timeSinceLastAction > this.timeoutInMinutes * 60000) {
      this.router.navigate(['/timeout'], { replaceUrl: true });
    }

  } else {

    const encryptedData = sessionStorage.getItem('data');

    if (encryptedData) {
      try {
        const decryptedData: any = this.decryptData(encryptedData);
        const ogdata: any = JSON.parse(decryptedData);
        this.loginhistoryid = ogdata.loginhistoryid;
        this.initListener();
        this.initTimer();
        this.startStatusCheckInterval();
      } catch (e) {
        this.router.navigate(['/login-page'], { replaceUrl: true });
      }
    } else {
      this.router.navigate(['/login-page'], { replaceUrl: true });
    }
  }

  this.initRouterListener();
}
  public initializeHeaders(): void {
    const token = sessionStorage.getItem('token');
    this.updateHeaders(token || '');
  }

  public getToken() {
    return !!sessionStorage.getItem('token');
  }

  public login(email: string, password: string, ip: any): Observable<any> {
    const credentialBody = {
      emailAddress: email,
      userPassword: password,
      ipAddress: ip,
    };
    const data = this.encryptobj(credentialBody);
    return this.http.post(`${this.basePath}${this.loginpath}`, { data });
  }

  public ngOnDestroy() {
    this.stopAllTimers();
    this.removeListeners();
    [
      this.routerEventsSubscription,
      this.navigationSubscription,
      this.statusCheckInterval,
    ].forEach((sub) => sub?.unsubscribe());
  }

  public updateHeaders(token: string): void {
    this.token = token;
    this.headers = new HttpHeaders({
      'Content-Type': 'application/json',
      X_ACCESS_TOKEN: `Bearer ${token}`,
    });
    this.headersMultipart = new HttpHeaders({
      X_ACCESS_TOKEN: `Bearer ${token}`,
    });
    this.options = { headers: this.headers };
    this.optionsMultipart = { headers: this.headersMultipart };
  }

  public startStatusCheckInterval(): void {
    if (this.statusCheckInterval) {
      this.statusCheckInterval.unsubscribe();
    }
    if (this.router.url === '/login-page' || this.router.url === '/timeout')
      return;
    if (!this.isLoggedIn()) return;
    this.statusCheckInterval = interval(10000).subscribe(() => {
      if (this.isLoggedIn()) {
        this.checkstatus(this.loginhistoryid);
      } else {
        this.stopStatusCheck();
      }
    });
  }

  public checkstatus(id: any) {
    if (!id || !this.isLoggedIn()) return;
    const encid: any = {
      loginHistoryId: id,
    };
    this.checkloginstatus(this.encryptobj(encid))
      .pipe(
        catchError((error) => {
          console.error('Status check failed:', error);
          return of(null); // Prevent subscription from dying
        }),
      )
      .subscribe((res: any) => {
        if (!res) return;
        const decrypt = this.decryptData(res?.response);
        const ogdata = JSON.parse(decrypt);
        if (res?.flag == 1 && ogdata?.loginHistoryStatus == 0) {
          this.handleConcurrentLogin();
        }
      });
  }

  private handleConcurrentLogin(): void {
    this.stopAllTimers();
    this.toast.error(
      `You have been logged out because your account was accessed from another location. If this wasn't you, please contact your administrator immediately.`,
      'New Login Detected',
      {
        timeOut: 10000,
        closeButton: true,
        progressBar: true,
        positionClass: 'toast-top-center',
      },
    );
    setTimeout(() => {
      this.clearHistoryAndNavigateToLogin();
    }, 300);
  }

  public initTimer(): void {
    this.stopTimer();
    if (!this.isLoggedIn()) return;

    this.lastAction = Date.now();
    sessionStorage.setItem('lastAction', this.lastAction.toString());
    this.isTimerActive = true;
    if (!this.listenersInitialized) {
      this.initListener();
    }
    this.timeLeftSeconds = this.timeoutInMinutes * 60;
    this.timer = setInterval(() => {
      if (!this.isLoggedIn()) {
        this.stopTimer();
        return;
      }
      const timeLeft = Math.max(
        0,
        Math.floor(
          (this.lastAction + this.timeoutInMinutes * 60000 - Date.now()) / 1000,
        ),
      );
      this.timeLeftSeconds = timeLeft;
      //
      if (this.timeLeftSeconds <= 0) {
        localStorage.setItem('timeoutState', 'true');
        this.handleTimeout();
      }
    }, 1000);
  }

  public handleTimeout(): void {
    this.stopAllTimers();
    this.matdialog.closeAll();
    this.stopStatusCheck();
    sessionStorage.clear();
    this.isLoggedInFlag = false;
    this.loginhistoryid = null;
    this.timeLeftSeconds = null;
    this.router.navigate(['/timeout'], { replaceUrl: true });
  }

  public stopTimer(): void {
    if (this.timer) {
      clearInterval(this.timer);
      this.timer = null;
    }
    this.isTimerActive = false;
    this.timeLeftSeconds = null;
  }

  public updateLastAction(): void {
    if (this.isLoggedIn()) {
      this.lastAction = Date.now();
      sessionStorage.setItem('lastAction', this.lastAction.toString());
      this.resetTimer();
    }
  }

  public initListener(): void {
    if (this.listenersInitialized) return;
    const events = ['click', 'mousemove', 'keypress', 'touchstart'];
    events.forEach((eventName) => {
      const handler = () => this.updateLastAction();
      document.addEventListener(eventName, handler);
      this.eventListeners.push({ event: eventName, handler });
    });
    this.listenersInitialized = true;
  }

  public removeListeners(): void {
    this.eventListeners.forEach(({ event, handler }) => {
      document.removeEventListener(event, handler);
    });
    this.eventListeners = [];
    this.listenersInitialized = false;
  }

  public initRouterListener(): void {
    this.router.events
      .pipe(
        filter(
          (event: any): event is NavigationEnd =>
            event instanceof NavigationEnd,
        ),
      )
      .subscribe((event: NavigationEnd) => {
        if (event.url === '/login-page' || event.url === '/timeout') {
          sessionStorage.clear;
          this.stopAllTimers();
        } else if (this.isLoggedInFlag && event.url !== '/login-page') {
          this.startStatusCheckInterval();
          if (!this.isTimerActive) {
            this.initTimer();
          }
        } else if (
          !this.isLoggedInFlag &&
          event.url !== '/login-page' &&
          event.url !== '/timeout'
        ) {
          this.clearHistoryAndNavigateToLogin();
        }
      });
  }

  public resetTimer(): void {
    this.stopTimer();
    this.lastAction = Date.now();
    sessionStorage.setItem('lastAction', this.lastAction.toString());
    this.initTimer();
  }

  public logout(): void {
    this.stopAllTimers();
    this.clearHistoryAndNavigateToLogin();
  }

  public clearHistoryAndNavigateToLogin(): void {
    this.stopAllTimers();
    this.matdialog.closeAll();
    sessionStorage.clear();
    this.isLoggedInFlag = false;
    this.loginhistoryid = null;
    this.timeLeftSeconds = null;
    this.stopStatusCheck(); // Ensure status check is stopped
    this.router.navigate(['/login-page'], {
      replaceUrl: true,
      state: { clearSession: true },
    });
  }

  public timeoutout(): void {
    this.stopAllTimers();
    this.clearHistoryAndNavigateToTimeout();
  }

  public clearHistoryAndNavigateToTimeout(): void {
    this.stopAllTimers();
    this.matdialog.closeAll();
    sessionStorage.clear();
    this.isLoggedInFlag = false;
    this.loginhistoryid = null;
    this.timeLeftSeconds = null;
    this.stopStatusCheck(); // Ensure status check is stopped
    this.router.navigate(['/timeout'], {
      replaceUrl: true,
      state: { clearSession: true },
    });
  }

  public stopAllTimers(): void {
    this.stopTimer();
    this.stopStatusCheck();
    this.removeListeners();
  }

  public stopStatusCheck(): void {
    if (this.statusCheckInterval) {
      this.statusCheckInterval.unsubscribe();
      this.statusCheckInterval = null as any;
    }
  }

  public isLoggedIn(): boolean {
    return (
      this.isLoggedInFlag || sessionStorage.getItem('isloggedIn') === 'true'
    );
  }

  logoff(data: any) {
    return this.http.put(
      `${this.basePath}${this.logoutAPI}`,
      { data },
      this.options,
    );
  }

  forgotpass() {
    this.isLoggedInFlag = true;
    this.router.navigateByUrl('/forgotpassword');
  }

  rememberedpass() {
    this.isLoggedInFlag = false;
    this.router.navigateByUrl('/login-page');
  }

  changepassword(data: any) {
    return this.http.put(
      `${this.basePath}${this.changepsw}`,
      { data },
      this.options,
    );
  }

  verifyforgotpassword(data: any) {
    return this.http.post(
      `${this.basePath}${this.forgotpassword}`,
      { data },
      this.options,
    );
  }

  getOtp(data: any) {
    return this.http.post(
      `${this.basePath}${this.VerifyOtp}`,
      { data },
      this.options,
    );
  }

  Resend(data: any) {
    return this.http.post(
      `${this.basePath}${this.ResendOTP}`,
      { data },
      this.options,
    );
  }

  ResetPassword(data: any): Observable<any> {
    setTimeout(() => {
      sessionStorage.clear();
      localStorage.clear();
      sessionStorage.removeItem('token');
    }, 1000);
    return this.http.post(
      `${this.basePath}${this.reset}`,
      { data },
      this.options,
    );
  }

  // ResetPassword(model:ResetPassword):Promise<any> {
  // return lastValueFrom( this.http.post(`${this.basePath}${this.reset}`,model,this.options ) );
  // }

  getalladmin(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewalladmin}`,
      { data },
      this.options,
    );
  }

  roleactionfilter(data: any) {
    return this.http.post(
      `${this.basePath}${this.roleactionfilterapi}`,
      { data },
      this.options,
    );
  }

  getallchangemanagement(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewallchangemanagement}`,
      { data },
      this.options,
    );
  }

  getallchangemanagementbyid(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewallchangemanagementbyid}`,
      { data },
      this.options,
    );
  }

  adminstatus(data: any) {
    return this.http.put(
      `${this.basePath}${this.changeadminstatus}`,
      { data },
      this.options,
    );
  }

  getalladminbyid(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewadminbyid}`,
      { data },
      this.options,
    );
  }

  Addadmin(data: FormData) {
    return this.http.post(
      `${this.basePath}${this.Addadmindata}`,
      data,
      this.optionsMultipart,
    );
  }

  AddchangeManagement(data: any) {
    return this.http.post(
      `${this.basePath}${this.AddallchangeManagement}`,
      { data },
      this.options,
    );
  }

  approvalL1(data: any) {
    return this.http.put(
      `${this.basePath}${this.addapproval1}`,
      { data },
      this.options,
    );
  }

  approvalL2(data: any) {
    return this.http.put(
      `${this.basePath}${this.addapproval2}`,
      { data },
      this.options,
    );
  }

  approvalL3(data: any) {
    return this.http.put(
      `${this.basePath}${this.addapproval3}`,
      { data },
      this.options,
    );
  }

  AddbackupchangeManagement(data: any) {
    return this.http.put(
      `${this.basePath}${this.AddallbackupchangeManagement}`,
      { data },
      this.options,
    );
  }

  EditchangeManagement(data: any) {
    return this.http.put(
      `${this.basePath}${this.editallchangeManagement}`,
      { data },
      this.options,
    );
  }

  editadmin(data: FormData) {
    return this.http.put(
      `${this.basePath}${this.editadmindata}`,
      data,
      this.optionsMultipart,
    );
  }

  unblock(data: any) {
    return this.http.put(
      `${this.basePath}${this.adminunblock}`,
      { data },
      this.options,
    );
  }

  Assetsviewall(data: any) {
    return this.http.post(
      `${this.basePath}${this.assetsviewall}`,
      { data },
      this.options,
    );
  }

  addassets(data: any) {
    return this.http.post(
      `${this.basePath}${this.Addassets}`,
      { data },
      this.options,
    );
  }

  Updateassets(data: any) {
    return this.http.put(
      `${this.basePath}${this.updateassets}`,
      { data },
      this.options,
    );
  }

  Assetsbyid(data: any) {
    return this.http.post(
      `${this.basePath}${this.assetsbyid}`,
      { data },
      this.options,
    );
  }

  Assetsactiveinactive(data: any) {
    return this.http.put(
      `${this.basePath}${this.assetsactiveinactive}`,
      { data },
      this.options,
    );
  }

  Assetsmakerviewall(data: any) {
    return this.http.post(
      `${this.basePath}${this.assetsmakerviewall}`,
      { data },
      this.options,
    );
  }

  Assetsmakeradd(data: any) {
    return this.http.post(
      `${this.basePath}${this.assetsmakeradd}`,
      { data },
      this.options,
    );
  }

  Assetsmakerupdate(data: any) {
    return this.http.put(
      `${this.basePath}${this.assetmakeredit}`,
      { data },
      this.options,
    );
  }

  AssetsMakerbyid(data: any) {
    return this.http.post(
      `${this.basePath}${this.assetsmakerbyid}`,
      { data },
      this.options,
    );
  }

  Assetsmakerstatus(data: any) {
    return this.http.put(
      `${this.basePath}${this.assetsmakerstatus}`,
      { data },
      this.options,
    );
  }

  Vendorview(data: any) {
    return this.http.post(
      `${this.basePath}${this.vendorviewall}`,
      { data },
      this.options,
    );
  }

  Vendoradd(data: any) {
    return this.http.post(
      `${this.basePath}${this.vendoradd}`,
      { data },
      this.options,
    );
  }

  Vendorupade(data: any) {
    return this.http.put(
      `${this.basePath}${this.Updateventor}`,
      { data },
      this.options,
    );
  }

  Vendorbyid(data: any) {
    return this.http.post(
      `${this.basePath}${this.ventorbyid}`,
      { data },
      this.options,
    );
  }

  VentorStatus(data: any) {
    return this.http.put(
      `${this.basePath}${this.ventorstatus}`,
      { data },
      this.options,
    );
  }

  AssetTrackerviewall(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.assettrackerviewall}`,
      { data },
      this.options,
    );
  }

  AssetTrackerStatus(data: any) {
    return this.http.put(
      `${this.basePath}${this.assettrackerstatus}`,
      { data },
      this.options,
    );
  }

  Assettrackeradd(data: any) {
    return this.http.post(
      `${this.basePath}${this.assettrackeradd}`,
      { data },
      this.options,
    );
  }

  AssettrackerUpdate(data: any) {
    return this.http.put(
      `${this.basePath}${this.assettrackerupdate}`,
      { data },
      this.options,
    );
  }

  Assettrackerbyid(data: any) {
    return this.http.post(
      `${this.basePath}${this.assetttrackerbyid}`,
      { data },
      this.options,
    );
  }

  vendorgetbystatus(data: any) {
    return this.http.post(
      `${this.basePath}${this.vendorgetbystatusapi}`,
      { data },
      this.options,
    );
  }

  addcompany(data: any) {
    return this.http.post(
      `${this.basePath}${this.AddCompany}`,
      { data },
      this.options,
    );
  }

  Editcompany(data: any) {
    return this.http.put(
      `${this.basePath}${this.Updatecompany}`,
      { data },
      this.options,
    );
  }

  Companygetall(data: any) {
    return this.http.post(
      `${this.basePath}${this.Companyviewall}`,
      { data },
      this.options,
    );
  }

  CompanygetByPermission(data: any) {
    return this.http.post(
      `${this.basePath}${this.CompanyGetByPermission}`,
      { data },
      this.options,
    );
  }

  CompanyStatus(data: any) {
    return this.http.put(
      `${this.basePath}${this.companystatus}`,
      { data },
      this.options,
    );
  }

  DesiginationViewAll(data: any) {
    return this.http.post(
      `${this.basePath}${this.DesigibationViewall}`,
      { data },
      this.options,
    );
  }

  Adddesigination(data: any) {
    return this.http.post(
      `${this.basePath}${this.adddesigination}`,
      { data },
      this.options,
    );
  }

  Desiginationbyid(data: any) {
    return this.http.post(
      `${this.basePath}${this.desiginationbyid}`,
      { data },
      this.options,
    );
  }

  UpdateDesigination(data: any) {
    return this.http.put(
      `${this.basePath}${this.Updatedesigination}`,
      { data },
      this.options,
    );
  }

  DesiginationStatus(data: any) {
    return this.http.put(
      `${this.basePath}${this.desiginationstatus}`,
      { data },
      this.options,
    );
  }

  DepartmentViewall(data: any) {
    return this.http.post(
      `${this.basePath}${this.departmetviewall}`,
      { data },
      this.options,
    );
  }

  Departmentstatus(data: any) {
    return this.http.put(
      `${this.basePath}${this.departmentactiveinactive}`,
      { data },
      this.options,
    );
  }

  AddDepartment(data: any) {
    return this.http.post(
      `${this.basePath}${this.adddepartment}`,
      { data },
      this.options,
    );
  }

  UpdateDepartment(data: any) {
    return this.http.put(
      `${this.basePath}${this.Updatedepartment}`,
      { data },
      this.options,
    );
  }

  Departmentbyid(data: any) {
    return this.http.post(
      `${this.basePath}${this.departmentbyid}`,
      { data },
      this.options,
    );
  }

  Employeeviewall(data: any) {
    return this.http.post(
      `${this.basePath}${this.employeeviewall}`,
      { data },
      this.options,
    );
  }

  Employeestatus(data: any) {
    return this.http.put(
      `${this.basePath}${this.employeeststus}`,
      { data },
      this.options,
    );
  }

  AddEmployee(data: FormData) {
    return this.http.post(
      `${this.basePath}${this.addemployee}`,
      data,
      this.optionsMultipart,
    );
  }

  UpdateEmployee(data: FormData) {
    return this.http.put(
      `${this.basePath}${this.updateemployee}`,
      data,
      this.optionsMultipart,
    );
  }

  EmployeebyId(data: any) {
    return this.http.post(
      `${this.basePath}${this.Employeebyid}`,
      { data },
      this.options,
    );
  }

  UnBlockEmp(data: any) {
    return this.http.put(
      `${this.basePath}${this.unblockemp}`,
      { data },
      this.options,
    );
  }

  PatchViewall(data: any) {
    return this.http.post(
      `${this.basePath}${this.Patchviewall}`,
      { data },
      this.options,
    );
  }

  AddPatch(data: FormData) {
    return this.http.post(
      `${this.basePath}${this.Addpatch}`,
      data,
      this.optionsMultipart,
    );
  }

  patchViewbyid(data: any) {
    return this.http.post(
      `${this.basePath}${this.patchviewbyid}`,
      { data },
      this.options,
    );
  }

  UpDatePatch(data: FormData) {
    return this.http.put(
      `${this.basePath}${this.UpdatePatch}`,
      data,
      this.optionsMultipart,
    );
  }

  ApprovalForTestDevice(data: any) {
    return this.http.put(
      `${this.basePath}${this.Approvetestdevice}`,
      { data },
      this.options,
    );
  }

  TestImageView(data: any) {
    return this.http.post(
      `${this.basePath}${this.PatchTestImageView}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  UpdateForTestDevice(data: FormData) {
    return this.http.put(
      `${this.basePath}${this.Updatefortestdevice}`,
      data,
      this.optionsMultipart,
    );
  }

  ApprovalForDeviceClient(data: any) {
    return this.http.put(
      `${this.basePath}${this.Approveclientdevice}`,
      { data },
      this.options,
    );
  }

  UpdateForclientDevice(data: FormData) {
    return this.http.put(
      `${this.basePath}${this.Updateforclientdevice}`,
      data,
      this.optionsMultipart,
    );
  }

  ServiceTicket(data: any) {
    return this.http.post(
      `${this.basePath}${this.Serviceticketviewall}`,
      { data },
      this.options,
    );
  }

  AddServiceTicket(data: FormData) {
    return this.http.post(
      `${this.basePath}${this.rasiseserviceticket}`,
      data,
      this.optionsMultipart,
    );
  }

  ticketByid(data: any) {
    return this.http.post(
      `${this.basePath}${this.Ticketbyid}`,
      { data },
      this.options,
    );
  }

  UpdateTicket(data: FormData) {
    return this.http.put(
      `${this.basePath}${this.updateticket}`,
      data,
      this.optionsMultipart,
    );
  }

  ViewTicketImage(data: any) {
    return this.http.post(
      `${this.basePath}${this.Viewserviceimage}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  Viewserviceresponseimage(data: any) {
    return this.http.post(
      `${this.basePath}${this.Viewserviceresponseimageapi}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  Viewserviceresponseimagehistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.Viewservicehistoryresponseimageapi}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  Viewservicetickethistory(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.Viewservicetickethistoryapi}`,
      { data },
      this.options,
    );
  }

  Processor(data: any) {
    return this.http.post(
      `${this.basePath}${this.Processorviewall}`,
      { data },
      this.options,
    );
  }

  AddPRocessor(data: any) {
    return this.http.post(
      `${this.basePath}${this.AddProcessor}`,
      { data },
      this.options,
    );
  }

  updateProcessor(data: any) {
    return this.http.put(
      `${this.basePath}${this.UpdateProcessor}`,
      { data },
      this.options,
    );
  }

  ProcessorByid(data: any) {
    return this.http.post(
      `${this.basePath}${this.Processorbyid}`,
      { data },
      this.options,
    );
  }

  ProcessorSTatus(data: any) {
    return this.http.put(
      `${this.basePath}${this.ProcessorStatus}`,
      { data },
      this.options,
    );
  }

  Assetsmodelgetall(data: any) {
    return this.http.post(
      `${this.basePath}${this.Assetmodelgetall}`,
      { data },
      this.options,
    );
  }

  AddAssetsModel(data: any) {
    return this.http.post(
      `${this.basePath}${this.Addassetmodel}`,
      { data },
      this.options,
    );
  }

  EditAssetsmodel(data: any) {
    return this.http.put(
      `${this.basePath}${this.UpdateAssetmodel}`,
      { data },
      this.options,
    );
  }

  Assetsmodelstatus(data: any) {
    return this.http.put(
      `${this.basePath}${this.statusassetmodel}`,
      { data },
      this.options,
    );
  }

  Assetsmodelbyid(data: any) {
    return this.http.post(
      `${this.basePath}${this.Assetmodelbyid}`,
      { data },
      this.options,
    );
  }

  UpdateIncidemtalert(data: any) {
    return this.http.put(
      `${this.basePath}${this.incidentalertupdate}`,
      { data },
      this.options,
    );
  }

  IncidentReportViewall(data: any) {
    return this.http.post(
      `${this.basePath}${this.Incidentreportgetall}`,
      { data },
      this.options,
    );
  }

  createIncidentReport(data: FormData) {
    return this.http.post(
      `${this.basePath}${this.incidentreportadd}`,
      data,
      this.optionsMultipart,
    );
  }

  IncidentReportUpdate(data: FormData) {
    return this.http.put(
      `${this.basePath}${this.incidenreportUpdate}`,
      data,
      this.optionsMultipart,
    );
  }

  IncidentImageview(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.IncidentImageView}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  IncidentReportgetByid(data: any) {
    return this.http.post(
      `${this.basePath}${this.Incidentreportgetbyid}`,
      { data },
      this.options,
    );
  }

  PermissionViewall(data: any) {
    return this.http.post(
      `${this.basePath}${this.ViewallPermission}`,
      { data },
      this.options,
    );
  }

  ADDPermission(data: any) {
    return this.http.post(
      `${this.basePath}${this.AddPermission}`,
      { data },
      this.options,
    );
  }

  MakeActiveInactivepermission(data: any) {
    return this.http.put(
      `${this.basePath}${this.PermissionStatus}`,
      { data },
      this.options,
    );
  }

  ActivePermissions() {
    return this.http.get(
      `${this.basePath}${this.ActivePermission}`,
      this.options,
    );
  }

  ViewAllSubPermissions(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.VieallSubpermission}`,
      { data },
      this.options,
    );
  }

  AddSubpermission(data: any) {
    return this.http.post(
      `${this.basePath}${this.AddSubPermission}`,
      { data },
      this.options,
    );
  }

  Subpermissionstatus(data: any) {
    return this.http.put(
      `${this.basePath}${this.SUbPermissionstatus}`,
      { data },
      this.options,
    );
  }

  CopypermissionforAdmin(data: any) {
    return this.http.post(
      `${this.basePath}${this.copyperadmin}`,
      { data },
      this.options,
    );
  }

  organizationgetbyid(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.organizationgetbyidapi}`,
      { data },
      this.options,
    );
  }

  CopypermissionforEmp(data: any) {
    return this.http.post(
      `${this.basePath}${this.copyperemp}`,
      { data },
      this.options,
    );
  }

  AddRoleAction(data: any) {
    return this.http.post(
      `${this.basePath}${this.RoleActionadd}`,
      { data },
      this.options,
    );
  }

  RoleActionStatus(data: any) {
    return this.http.put(
      `${this.basePath}${this.Roleactionstatus}`,
      { data },
      this.options,
    );
  }

  ComplianceReportviewall(data: any) {
    return this.http.post(
      `${this.basePath}${this.Compliancereportviewall}`,
      { data },
      this.options,
    );
  }

  Createcompliancereport(data: FormData) {
    return this.http.post(
      `${this.basePath}${this.Createreport}`,
      data,
      this.optionsMultipart,
    );
  }

  UpdateComplianceReport(data: FormData) {
    return this.http.put(
      `${this.basePath}${this.UpdateReport}`,
      data,
      this.optionsMultipart,
    );
  }

  CompliancereportByid(data: any) {
    return this.http.post(
      `${this.basePath}${this.createreportbyid}`,
      { data },
      this.options,
    );
  }

  Tychecategorygetall(data: any) {
    return this.http.post(
      `${this.basePath}${this.tychecategorygetall}`,
      { data },
      this.options,
    );
  }

  TycheCategoryadd(data: any) {
    return this.http.post(
      `${this.basePath}${this.Tychecategoryadd}`,
      { data },
      this.options,
    );
  }

  TycheCategorybyid(data: any) {
    return this.http.post(
      `${this.basePath}${this.Tychecategorybyid}`,
      { data },
      this.options,
    );
  }

  TychecategoryUpdate(data: any) {
    return this.http.put(
      `${this.basePath}${this.Tychecategoryupdate}`,
      { data },
      this.options,
    );
  }

  TycheCategorystatus(data: any) {
    return this.http.put(
      `${this.basePath}${this.Tychecategorystatus}`,
      { data },
      this.options,
    );
  }

  TycheComplianceReportViewall(data: any) {
    return this.http.post(
      `${this.basePath}${this.TychecomplianceViewall}`,
      { data },
      this.options,
    );
  }

  getallassetbyphysicalstatus(data: any) {
    return this.http.post(
      `${this.basePath}${this.getallassetbyphysicalstatusapi}`,
      { data },
      this.options,
    );
  }

  TycheComplianceAdd(data: FormData) {
    return this.http.post(
      `${this.basePath}${this.AddTycheCompliance}`,
      data,
      this.optionsMultipart,
    );
  }

  TycheComplianceUpdate(data: FormData) {
    return this.http.put(
      `${this.basePath}${this.UpdateTycheCompliance}`,
      data,
      this.optionsMultipart,
    );
  }

  TycheComplianceViewByid(data: any) {
    return this.http.post(
      `${this.basePath}${this.Tychecompliancebyid}`,
      { data },
      this.options,
    );
  }

  tycheDocview(data: any) {
    return this.http.post(
      `${this.basePath}${this.Tychecompliancedocument}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  vendorDocview(data: any) {
    return this.http.post(
      `${this.basePath}${this.vendorcompliancedocument}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  Tychedocviewpassword(data: any) {
    return this.http.post(
      `${this.basePath}${this.Tychecompliancedocpassword}`,
      { data },
      this.options,
    );
  }

  vendordocviewpassword(data: any) {
    return this.http.post(
      `${this.basePath}${this.vendorcmpliancedocpassword}`,
      { data },
      this.options,
    );
  }

  adminprofileimgview(data: any) {
    return this.http.post(
      `${this.basePath}${this.adminprofileimgviewapi}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  employeprofileimageview(data: any) {
    return this.http.post(
      `${this.basePath}${this.employeprofileimgviewapi}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  getpatchuploadefilebyid(data: any) {
    return this.http.post(
      `${this.basePath}${this.getpatchuploadefilebyidapi}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  resubmissionhistoryreject(data: any) {
    return this.http.post(
      `${this.basePath}${this.resubmissionhistoryrejectapi}`,
      { data },
      this.options,
    );
  }

  resubmissionhistoryupdate(data: any) {
    return this.http.post(
      `${this.basePath}${this.resubmissionhistoryupdateapi}`,
      { data },
      this.options,
    );
  }

  implementationhistorygetall(data: any) {
    return this.http.post(
      `${this.basePath}${this.implementationhistorygetallapi}`,
      { data },
      this.options,
    );
  }

  formhistoryviewbyid(data: any) {
    return this.http.post(
      `${this.basePath}${this.formhistoryviewbyidapi}`,
      { data },
      this.options,
    );
  }

  getassetbrandbytypeid(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.getassetbrandbytypeidapi}`,
      { data },
      this.options,
    );
  }

  getmodel(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.getmodelapi}`,
      { data },
      this.options,
    );
  }

  assetreasign(data: any) {
    return this.http.put(
      `${this.basePath}${this.assetreasignapi}`,
      { data },
      this.options,
    );
  }

  getassethistorybyid(data: any) {
    return this.http.post(
      `${this.basePath}${this.getassethistorybyidapi}`,
      { data },
      this.options,
    );
  }

  assetreviewer(data: any) {
    return this.http.post(
      `${this.basePath}${this.assetreviewerapi}`,
      { data },
      this.options,
    );
  }

  getallpendingasset(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.getallpendingassetapi}`,
      { data },
      this.options,
    );
  }

  getallassetsbyorganization(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.getallassetsbyorganizationapi}`,
      { data },
      this.options,
    );
  }

  approvependingasset(data: any) {
    return this.http.post(
      `${this.basePath}${this.approvependingassetapi}`,
      { data },
      this.options,
    );
  }

  getallassetbytypeid(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.getallassetbytypeidapi}`,
      { data },
      this.options,
    );
  }

  getassetupdatehistorybyid(data: any) {
    return this.http.post(
      `${this.basePath}${this.getassetupdatehistorybyidapi}`,
      { data },
      this.options,
    );
  }

  getassetupdatehistorybyhistoryid(data: any) {
    return this.http.post(
      `${this.basePath}${this.getassetupdatehistorybyhistoryidapi}`,
      { data },
      this.options,
    );
  }

  getassetswithoutpheripheral() {
    return this.skiploader.get(
      `${this.basePath}${this.getassetswithoutpheripheralapi}`,
      this.options,
    );
  }

  getallassereviewedhistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.getallassereviewedhistoryapi}`,
      { data },
      this.options,
    );
  }

  getallasseapprovedhistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.getallasseapprovedhistoryapi}`,
      { data },
      this.options,
    );
  }

  getbyidassereviewedhistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.getbyidassereviewedhistoryapi}`,
      { data },
      this.options,
    );
  }

  getbyidasseapprovedhistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.getbyidasseapprovedhistoryapi}`,
      { data },
      this.options,
    );
  }

  getbyidassetAIhistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.getbyidassetAIhistoryapi}`,
      { data },
      this.options,
    );
  }

  getallemployee(data: any) {
    return this.http.post(
      `${this.basePath}${this.getallemployeeapi}`,
      { data },
      this.options,
    );
  }

  getpatchupdatehistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.getpatchupdatehistoryapi}`,
      { data },
      this.options,
    );
  }

  getpatchmodifiedhistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.getpatchmodifiedhistoryapi}`,
      { data },
      this.options,
    );
  }

  getpatchevidencehistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.getpatchevidencehistoryapi}`,
      { data },
      this.options,
    );
  }

  gettestupdatehistoryimage(data: any) {
    return this.http.post(
      `${this.basePath}${this.gettestupdatehistoryimageapi}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  getpatchmodifiedfilehistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.getpatchmodifiedfilehistoryapi}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  getclientupdatehistorypdf(data: any) {
    return this.http.post(
      `${this.basePath}${this.getclientupdatehistorypdfapi}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  getclientupdatepdf(data: any) {
    return this.http.post(
      `${this.basePath}${this.getclientupdatepdfapi}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  getbackupdocument(data: any) {
    return this.http.post(
      `${this.basePath}${this.getbackupdocumentapi}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  productiondevicerequest(data: any) {
    return this.http.post(
      `${this.basePath}${this.productiondevicerequestapi}`,
      { data },
      this.options,
    );
  }

  editproductiondevicerequest(data: any) {
    return this.http.put(
      `${this.basePath}${this.editproductiondevicerequestapi}`,
      { data },
      this.options,
    );
  }

  getrequesteddevicebyid(data: any) {
    return this.http.post(
      `${this.basePath}${this.getrequesteddevicebyidapi}`,
      { data },
      this.options,
    );
  }

  updaterequesteddevice(data: any) {
    return this.http.post(
      `${this.basePath}${this.updaterequesteddeviceapi}`,
      { data },
      this.options,
    );
  }

  getrequesteddevicebystatus(data: any) {
    return this.http.post(
      `${this.basePath}${this.getrequesteddevicebystatusapi}`,
      { data },
      this.options,
    );
  }

  getrequesteddevicehistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.getrequesteddevicehistoryapi}`,
      { data },
      this.options,
    );
  }

  getclientupdatehistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.getclientupdatehistoryapi}`,
      { data },
      this.options,
    );
  }

  patchfinalapproval(data: any) {
    return this.http.put(
      `${this.basePath}${this.patchfinalapprovalapi}`,
      { data },
      this.options,
    );
  }

  viewpatchistorybackupdocumenth(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewpatchistorybackupdocumenthapi}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  getfinalapprovalhistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.getfinalapprovalhistoryapi}`,
      { data },
      this.options,
    );
  }

  getrequesteddeviceshistory(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.getrequesteddeviceshistoryapi}`,
      { data },
      this.options,
    );
  }

  escalationcreation(data: any) {
    return this.http.post(
      `${this.basePath}${this.escalationcreationapi}`,
      { data },
      this.options,
    );
  }

  getallescalation(data: any) {
    return this.http.post(
      `${this.basePath}${this.getallescalationapi}`,
      { data },
      this.options,
    );
  }

  getescalationdetailsbyid(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.getescalationdetailsbyidapi}`,
      { data },
      this.options,
    );
  }

  getallincidentmodifiedhistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.getallincidentmodifiedhistoryapi}`,
      { data },
      this.options,
    );
  }

  viewincidentmodifiedhistoryimage(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewincidentmodifiedhistoryimageapi}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  getallemailloghistory(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.getallemailloghistoryapi}`,
      { data },
      this.options,
    );
  }

  getincidentmodifiedhistorybyid(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.getincidentmodifiedhistorybyidapi}`,
      { data },
      this.options,
    );
  }

  closureformsubmit(data: FormData) {
    return this.http.put(
      `${this.basePath}${this.closureformsubmitapi}`,
      data,
      this.optionsMultipart,
    );
  }

  incidentfinalapprovalsubmit(data: any) {
    return this.http.put(
      `${this.basePath}${this.incidentfinalapprovalsubmitapi}`,
      { data },
      this.options,
    );
  }

  getallfinalapprovalhistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.getallfinalapprovalhistoryapi}`,
      { data },
      this.options,
    );
  }

  viewincidentclosuredocument(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.viewincidentclosuredocumentapi}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  getallincidentclosurehistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.getallincidentclosurehistoryapi}`,
      { data },
      this.options,
    );
  }

  viewincidentclosuredocumenthistory(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.viewincidentclosuredocumenthistoryapi}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  fetchdetailsbyemail(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.fetchdetailsbyemailapi}`,
      { data },
      this.options,
    );
  }

  fetchassetdetailsbyemail(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.fetchaccetdetailsbyemailapi}`,
      { data },
      this.options,
    );
  }

  getassetForUsersOrUnAssigned(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.getassetforusersorunassigned}`,
      { data },
      this.options,
    );
  }

  fetchhostname(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.fetchhostnameapi}`,
      { data },
      this.options,
    );
  }

  getallservicehistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.getallservicehistoryapi}`,
      { data },
      this.options,
    );
  }

  serviceassetcreation(data: any) {
    return this.http.post(
      `${this.basePath}${this.serviceassetcreationapi}`,
      { data },
      this.options,
    );
  }

  serviceassetdailyupdate(data: any) {
    return this.http.put(
      `${this.basePath}${this.serviceassetdailyupdateapi}`,
      { data },
      this.options,
    );
  }

  itservicedailyupdate(data: any) {
    return this.http.put(
      `${this.basePath}${this.itservicedailyupdateapi}`,
      { data },
      this.options,
    );
  }

  serviceassetclosure(data: FormData) {
    return this.http.put(
      `${this.basePath}${this.serviceassetclosureapi}`,
      data,
      this.optionsMultipart,
    );
  }

  viewservicebill(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewservicebillapi}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  serviceassethistory(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.serviceassethistoryapi}`,
      { data },
      this.options,
    );
  }

  itservicecommenthistory(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.itservicecommenthistoryapi}`,
      { data },
      this.options,
    );
  }

  getcaptcha(id: any) {
    return this.skiploader.get(`${this.basePath}${this.getcaptchaapi}${id}`);
  }

  getpermissions(data: any): Observable<any> {
    return this.http.post(
      `${this.basePath}${this.getpermissionsapi}`,
      { data },
      this.options,
    );
  }

  checkloginstatus(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.checkloginstatusapi}`,
      { data },
      this.options,
    );
  }

  getloginhistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.getloginhistoryapi}`,
      { data },
      this.options,
    );
  }

  //SSL Management
    addssl(data: FormData) {
        return this.http.post(`${this.basePath}${this.addsslapi}`, data, this.optionsMultipart)
    }

    editssl(data: FormData) {
        return this.http.put(`${this.basePath}${this.editsslapi}`, data, this.optionsMultipart)
    }

    getallssl(data: any) {
        return this.http.post(`${this.basePath}${this.getallsslapi}`, { data }, this.options)
    }

    sslgetbyid(data: any) {
        return this.http.post(`${this.basePath}${this.sslgetbyidapi}`, { data }, this.options)
    }

    sslpassverify(data: any) {
        return this.http.post(`${this.basePath}${this.sslpassverifyapi}`, { data }, this.options)
    }

    viewssldocumentbyid(data: any) {
        return this.http.post(`${this.basePath}${this.viewssldocumentbyidapi}`, { data }, { ...this.options, ...{ responseType: 'blob' } })
    }

    viewsslhistorybyid(data: any) {
        return this.http.post(`${this.basePath}${this.viewsslhistorybyidapi}`, { data }, this.options)
    }

    viewsslhistorydocumentbyid(data: any) {
        return this.http.post(`${this.basePath}${this.viewsslhistorydocumentbyidapi}`, { data }, this.options)
    }

    viewsslhistorybyfilterid(data: any) {
        return this.http.post(`${this.basePath}${this.viewsslhistorybyfilteridapi}`, { data }, this.options)
    }
 
   
    // updatepassword For SSL

        
    ViewlinkbuidforSSL(data: any){
        return this.skiploader.post(`${this.basePath}${this.viewlinkSSL}`,{data},this.Passwordtoken)
    }

    Changepasswordrequest(data: any){
        return this.http.post(`${this.basePath}${this.changepasswordrequestforSSL}`,{data},this.Passwordtoken)
    }

    SendotpforSSl(data: any){
        return this.skiploader.post(`${this.basePath}${this.sendotpforSSL}`,{data},this.Passwordtoken)
    }

    VerifyotpforSSL(data: any){
        return this.skiploader.post(`${this.basePath}${this.verifyotpforSSl}`,{data},this.Passwordtoken)
    }

    Resentpassword(data: any){
        return this.skiploader.post(`${this.basePath}${this.resentpassword}`,{data},this.Passwordtoken)
    }
 
 


    
    //Email License Management
    addemaillicense(data: any) {
        return this.http.post(`${this.basePath}${this.addemaillicenseapi}`, { data }, this.options)
    }

    getallemaillicense(data: any) {
        return this.http.post(`${this.basePath}${this.getallemaillicenseapi}`, { data }, this.options)
    }

    getbyidemaillicense(data: any) {
        return this.http.post(`${this.basePath}${this.emaillicensegetbyidapi}`, { data }, this.options)
    }

    editemaillicense(data: any) {
        return this.http.put(`${this.basePath}${this.editemaillicenseapi}`, { data }, this.options)
    }

    emaillicensehistorybyid(data: any) {
        return this.http.post(`${this.basePath}${this.emaillicensehistorybyidapi}`, { data }, this.options)
    }

     //Employe Policy
    addemployeepolicy(data: FormData) {
        return this.http.post(`${this.basePath}${this.addemployeepolicyapi}`, data, this.optionsMultipart)
    }

    employeepolicygetbyid(data: any) {
        return this.http.post(`${this.basePath}${this.employeepolicygetbyidapi}`, { data }, this.options)
    }

    editemployeepolicy(data: FormData) {
        return this.http.put(`${this.basePath}${this.editemployeepolicyapi}`, data, this.optionsMultipart)
    }

    employeepolicyhistorybyid(data: any) {
        return this.http.post(`${this.basePath}${this.employeepolicyhistorybyidapi}`, { data }, this.options)
    }

    getallemployeepolicy(data: any) {
        return this.http.post(`${this.basePath}${this.getallemployeepolicyapi}`, { data }, this.options)
    }

    employeepolicypassverify(data: any) {
        return this.http.post(`${this.basePath}${this.employeepolicypassverifyapi}`, { data }, this.options)
    }

    employeepolicydocumentview(data: any) {
        return this.http.post(`${this.basePath}${this.employeepolicydocumentviewapi}`, { data }, { ...this.options, ...{ responseType: 'blob' } })
    }

    employeepolicyacknowledgement(data: any) {
        return this.http.post(`${this.basePath}${this.employeepolicyacknowledgementapi}`, { data }, this.options)
    }

    Emppolicyviewbylinkid(data: any){
        return this.skiploader.post(`${this.basePath}${this.viewbylinkidforemppolicy}`,{data},this.Passwordtoken)
    }

    Emppolicychangepasswordrequest(data: any){
        return this.http.post(`${this.basePath}${this.changepasswordrequestforemppolicy}`,{data},this.Passwordtoken)
    }

    EMppolicysendotp(data: any){
        return this.skiploader.post(`${this.basePath}${this.sendotpforemppolicy}`,{data},this.Passwordtoken)
    }

    Emppolicyverifyotp(data: any){
        return this.skiploader.post(`${this.basePath}${this.verifyotpforemppolicy}`,{data},this.Passwordtoken)
    }

    Empresetpassword(data: any){
        return this.skiploader.post(`${this.basePath}${this.resetpassword}`,{data},this.Passwordtoken)
    }
 
 

  encryptobj(data: any): string {
    const dataString = JSON?.stringify(data);
    const key = CryptoJS?.enc?.Utf8?.parse(this.secretKey);
    const iv = CryptoJS.lib?.WordArray?.random(16);
    const encrypted = CryptoJS?.AES?.encrypt(dataString, key, {
      iv: iv,
      mode: CryptoJS?.mode?.CBC,
      padding: CryptoJS?.pad?.Pkcs7,
    });
    const combined = iv?.concat(encrypted?.ciphertext);
    return CryptoJS?.enc?.Base64?.stringify(combined);
  }

  encryptData(data: any): string {
    const dataString = JSON.stringify(data);
    const key = CryptoJS?.enc?.Utf8?.parse(this?.secretKey);
    const iv = CryptoJS?.lib?.WordArray?.random(16);
    const encrypted = CryptoJS?.AES?.encrypt(dataString, key, {
      iv: iv,
      mode: CryptoJS?.mode?.CBC,
      padding: CryptoJS?.pad?.Pkcs7,
    });
    const combined = iv?.concat(encrypted?.ciphertext);
    return CryptoJS?.enc?.Base64?.stringify(combined);
  }

  decryptData(encryptedData: string): string {
    const key = CryptoJS?.enc?.Utf8?.parse(this?.secretKey);
    const combined = CryptoJS?.enc?.Base64?.parse(encryptedData);
    const iv = CryptoJS?.lib?.WordArray?.create(
      combined?.words?.slice(0, 4),
      16,
    );
    const ciphertext = CryptoJS?.lib?.WordArray?.create(
      combined?.words?.slice(4),
    );
    const decrypted = CryptoJS?.AES?.decrypt(
      { ciphertext: ciphertext } as any,
      key,
      { iv: iv, mode: CryptoJS?.mode?.CBC, padding: CryptoJS?.pad?.Pkcs7 },
    );
    return decrypted?.toString(CryptoJS?.enc?.Utf8);
  }

  getmoduleslist(data: any) {
    return this.http.post(
      `${this.basePath}${this.moduleslistapi}`,
      { data },
      this.options,
    );
  }

  getauditlogs(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.getauditlogsapi}`,
      { data },
      this.options,
    );
  }

  reportsgetall(data: any) {
    return this.http.post(
      `${this.basePath}${this.repotrsviewallapi}`,
      { data },
      this.options,
    );
  }

  generatereport(data: any) {
    return this.http.post(
      `${this.basePath}${this.reportgeneration}`,
      { data },
      this.options,
    );
  }

  reportcheckstatus(data: any) {
    return this.http.post(
      `${this.basePath}${this.repotrstatuscheck}`,
      { data },
      this.options,
    );
  }

  downloadreport(data: any) {
    return this.http.post(
      `${this.basePath}${this.reportdownload}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  // Training Category

  addTrainingCategory(data: any) {
    return this.http.post(
      `${this.basePath}${this.addtrainingcategory}`,
      { data },
      this.options,
    );
  }

  getAllTrainingCategory(data: any) {
    return this.http.post(
      `${this.basePath}${this.getalltrainingcategory}`,
      { data },
      this.options,
    );
  }

  getTrainingCategoryById(data: any) {
    return this.http.post(
      `${this.basePath}${this.gettrainingcategorybyid}`,
      { data },
      this.options,
    );
  }

  trainingCategoryStatus(data: any) {
    return this.http.put(
      `${this.basePath}${this.trainingcategorystatus}`,
      { data },
      this.options,
    );
  }

  editTrainingCategory(data: any) {
    return this.http.put(
      `${this.basePath}${this.edittrainingcategory}`,
      { data },
      this.options,
    );
  }

  // Training Name

  addTrainingName(data: any) {
    return this.http.post(
      `${this.basePath}${this.addtrainingname}`,
      { data },
      this.options,
    );
  }

  getAllTrainingName(data: any) {
    return this.http.post(
      `${this.basePath}${this.getalltrainingname}`,
      { data },
      this.options,
    );
  }

  getTrainingNameById(data: any) {
    return this.http.post(
      `${this.basePath}${this.gettrainingnamebyid}`,
      { data },
      this.options,
    );
  }

  trainingNameStatus(data: any) {
    return this.http.put(
      `${this.basePath}${this.trainingnamestatus}`,
      { data },
      this.options,
    );
  }

  editTrainingName(data: any) {
    return this.http.put(
      `${this.basePath}${this.edittrainingname}`,
      { data },
      this.options,
    );
  }

  // Training Creation
  addTraining(data: FormData) {
    return this.http.post(
      `${this.basePath}${this.addtraining}`,
      data,
      this.optionsMultipart,
    );
  }

  editTraining(data: FormData) {
    return this.http.put(
      `${this.basePath}${this.edittraining}`,
      data,
      this.optionsMultipart,
    );
  }

  trainingStatusUpdate(data: any) {
    return this.http.put(
      `${this.basePath}${this.trainingstatusupdate}`,
      { data },
      this.optionsMultipart,
    );
  }

  getAllTrainingCreation(data: any) {
    return this.http.post(
      `${this.basePath}${this.getalltrainings}`,
      { data },
      this.options,
    );
  }

  getTrainingById(data: any) {
    return this.http.post(
      `${this.basePath}${this.gettrainingbyid}`,
      { data },
      this.options,
    );
  }

  trainingHistoryById(data: any) {
    return this.http.post(
      `${this.basePath}${this.traininghistorybyid}`,
      { data },
      this.options,
    );
  }

  getEvidenceImage(data: any) {
    return this.http.post(
      `${this.basePath}${this.getevidenceimage}`,
      { data },
      this.options,
    );
  }

  getTrainingImage(data: any) {
    return this.http.post(
      `${this.basePath}${this.gettrainingimage}`,
      { data },
      this.options,
    );
  }

  trainingHistoryByHistoryId(data: any) {
    return this.http.post(
      `${this.basePath}${this.gettraininghistorybyid}`,
      { data },
      this.options,
    );
  }

  getEvidenceHistoryImage(data: any) {
    return this.http.post(
      `${this.basePath}${this.getevidencehistoryimage}`,
      { data },
      this.options,
    );
  }

  acknowledgeTraining(data: any) {
    return this.http.post(
      `${this.basePath}${this.acknowledgetraining}`,
      { data },
      this.options,
    );
  }

  getAllTrainingsDropdown(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.getalltrainingsdropdown}`,
      { data },
      this.options,
    );
  }

  getAttendanceHistoryImage(data: any) {
    return this.http.post(
      `${this.basePath}${this.getattendancehistoryimage}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  getTrainingHistoryImage(data: any) {
    return this.http.post(
      `${this.basePath}${this.gettraininghistoryimage}`,
      { data },
      this.options,
    );
  }

  getAttendanceImage(data: any) {
    return this.http.post(
      `${this.basePath}${this.getattendanceimage}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  // Assessement
  addAssessment(data: any) {
    return this.http.post(
      `${this.basePath}${this.addassessment}`,
      { data },
      this.options,
    );
  }

  editAssessment(data: any) {
    return this.http.put(
      `${this.basePath}${this.editassessment}`,
      { data },
      this.options,
    );
  }

  getAllAssessment(data: any) {
    return this.skiploader.post(
      `${this.basePath}${this.getallassessment}`,
      { data },
      this.options,
    );
  }

  cancelAssessment(data: any) {
    return this.http.put(
      `${this.basePath}${this.cancelassessment}`,
      { data },
      this.options,
    );
  }

  publishAssessment(data: any) {
    return this.http.put(
      `${this.basePath}${this.publishassessment}`,
      { data },
      this.options,
    );
  }

  generateQuestions(data: any) {
    return this.http.post(
      `${this.basePath}${this.generatequestions}`,
      { data },
      this.options,
    );
  }

  getAllQuestions(data: any) {
    return this.http.post(
      `${this.basePath}${this.getallquestions}`,
      { data },
      this.options,
    );
  }

  deleteQuestions(data: any) {
    return this.http.put(
      `${this.basePath}${this.deletequestions}`,
      { data },
      this.options,
    );
  }

  reviewQuestion(data: any) {
    return this.http.put(
      `${this.basePath}${this.reviewquestion}`,
      { data },
      this.options,
    );
  }

  assessmentHistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.assessmenthistory}`,
      { data },
      this.options,
    );
  }

  viewAllAssessment(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewallassessment}`,
      { data },
      this.options,
    );
  }

  viewConductLog(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewconductlog}`,
      { data },
      this.options,
    );
  }

  viewConductImage(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewconductimage}`,
      { data },
      { ...this.optionsMultipart, ...{ responseType: 'blob' } },
    );
  }

  getCertificate(data: any) {
    return this.http.post(
      `${this.basePath}${this.getcertificate}`,
      { data },
      { ...this.optionsMultipart, ...{ responseType: 'blob' } },
    );
  }

  publishResult(data: any) {
    return this.http.post(
      `${this.basePath}${this.publishresult}`,
      { data },
      this.options,
    );
  }

  publishAll(data: any) {
    return this.http.post(
      `${this.basePath}${this.publishall}`,
      { data },
      this.options,
    );
  }

  reAssign(data: any) {
    return this.http.post(
      `${this.basePath}${this.reassign}`,
      { data },
      this.options,
    );
  }

  revokeSession(data: any) {
    return this.http.post(
      `${this.basePath}${this.revokesession}`,
      { data },
      this.options,
    );
  }

  employeeAssessmentHistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.employeeassessmenthistory}`,
      { data },
      this.options,
    );
  }

  // Test Module
  getAllTest(data: any) {
    return this.http.post(
      `${this.basePath}${this.getalltest}`,
      { data },
      this.options,
    );
  }

  getQuestions(data: any) {
    return this.http.post(
      `${this.basePath}${this.getquestions}`,
      { data },
      this.options,
    );
  }

  submitAnswer(data: any) {
    return this.http.put(
      `${this.basePath}${this.submitanswer}`,
      { data },
      this.options,
    );
  }

  quickSubmit(data: FormData) {
    return this.http.post(
      `${this.basePath}${this.quicksubmit}`,
      data,
      this.optionsMultipart,
    );
  }

  addAttendeeImage(data: FormData) {
    return this.http.post(
      `${this.basePath}${this.addattendeeimage}`,
      data,
      this.optionsMultipart,
    );
  }

  getAttendeeImage(data: any) {
    return this.http.post(
      `${this.basePath}${this.getattendeeimage}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  // Assessment Topics
  getAllTopics(data: any) {
    return this.http.post(
      `${this.basePath}${this.getalltopics}`,
      { data },
      this.options,
    );
  }

  topicStatusUpdate(data: any) {
    return this.http.put(
      `${this.basePath}${this.topicstatusupdate}`,
      { data },
      this.options,
    );
  }

  editTopic(data: any) {
    return this.http.put(
      `${this.basePath}${this.edittopic}`,
      { data },
      this.options,
    );
  }

  addTopic(data: any) {
    return this.http.post(
      `${this.basePath}${this.addtopic}`,
      { data },
      this.options,
    );
  }

  // Certificate Content
  addCertificateContent(data: any) {
    return this.http.post(
      `${this.basePath}${this.addcertificatecontent}`,
      { data },
      this.options,
    );
  }

  editCertificateContent(data: any) {
    return this.http.put(
      `${this.basePath}${this.editcertificatecontent}`,
      { data },
      this.options,
    );
  }

  contentStatusUpdate(data: any) {
    return this.http.put(
      `${this.basePath}${this.contentstatusupdate}`,
      { data },
      this.options,
    );
  }

  getAllContent(data: any) {
    return this.http.post(
      `${this.basePath}${this.getallcontent}`,
      { data },
      this.options,
    );
  }

  // Certificate Signers
  addCertificateSigners(data: FormData) {
    return this.http.post(
      `${this.basePath}${this.addcertificatesigners}`,
      data,
      this.optionsMultipart,
    );
  }

  editCertificateSigners(data: FormData) {
    return this.http.put(
      `${this.basePath}${this.editcertificatesigners}`,
      data,
      this.optionsMultipart,
    );
  }

  certificateSignersStatus(data: any) {
    return this.http.put(
      `${this.basePath}${this.certificatesignersstatus}`,
      { data },
      this.options,
    );
  }

  getAllCertificateSigners(data: any) {
    return this.http.post(
      `${this.basePath}${this.getallcertificatesigners}`,
      { data },
      this.options,
    );
  }

  viewCertificateSignersImage(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewcertificatesignersimage}`,
      { data },
      { ...this.optionsMultipart, ...{ responseType: 'blob' } },
    );
  }

  // Board Resolution
  Createboard(formdata: FormData) {
    return this.http.post(
      `${this.basePath}${this.createboard}`,
      formdata,
      this.optionsMultipart,
    );
  }

  Getallboard(data: any) {
    return this.http.post(
      `${this.basePath}${this.getboard}`,
      { data },
      this.options,
    );
  }

  Viewallimage(id: any) {
    return this.http.get(`${this.basePath}${this.viewimage}/${id}`, {
      ...this.options,
      ...{ responseType: 'blob' },
    });
  }

  verifyimage(data: any) {
    return this.http.post(
      `${this.basePath}${this.passwordverimg}`,
      { data },
      this.options,
    );
  }

  Editboard(formdata: FormData) {
    return this.http.put(
      `${this.basePath}${this.editboard}`,
      formdata,
      this.optionsMultipart,
    );
  }

  Editbyid(data: any) {
    return this.http.post(
      `${this.basePath}${this.boardgetbyid}`,
      { data },
      this.options,
    );
  }

  Boardupdatestatus(data: any) {
    return this.http.put(
      `${this.basePath}${this.updatestatusresolution}`,
      { data },
      this.options,
    );
  }

  Boardhistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.resolutionhistory}`,
      { data },
      this.options,
    );
  }

  assessmentQuestions(data: any) {
    return this.http.post(
      `${this.basePath}${this.assessmentquestions}`,
      { data },
      this.options,
    );
  }

  // Policy and Procedure

  Createpolicy(formdata: FormData) {
    return this.http.post(
      `${this.basePath}${this.createpolicyprocedure}`,
      formdata,
      this.optionsMultipart,
    );
  }

  Updatepolicy(formdata: FormData) {
    return this.http.put(
      `${this.basePath}${this.updatepolicyprocedure}`,
      formdata,
      this.optionsMultipart,
    );
  }

  Viewpolicy(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewpolicyprocedure}`,
      { data },
      this.options,
    );
  }

  policyviewbyid(data: any) {
    return this.http.post(
      `${this.basePath}${this.policybyid}`,
      { data },
      this.options,
    );
  }

  policyhistoryview(data: any) {
    return this.http.post(
      `${this.basePath}${this.historypolicyprocedure}`,
      { data },
      this.options,
    );
  }

  Reviewhistoryview(data: any) {
    return this.http.post(
      `${this.basePath}${this.reviewhistory}`,
      { data },
      this.options,
    );
  }

  Approvaleviewhistoryview(data: any) {
    return this.http.post(
      `${this.basePath}${this.approvalhistory}`,
      { data },
      this.options,
    );
  }

  historypolicybyid(data: any) {
    return this.http.post(
      `${this.basePath}${this.policyhistorybyid}`,
      { data },
      this.options,
    );
  }

  Viewreview(data: any) {
    return this.http.put(
      `${this.basePath}${this.reviewapi}`,
      { data },
      this.options,
    );
  }

  Pdfgenaration(data: any) {
    return this.http.post(
      `${this.basePath}${this.genratepdf}`,
      { data },
      this.options,
    );
  }

  Viewpdf(data: any) {
    return this.http.post(
      `${this.basePath}${this.pdfview}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  PDFdocumentview(data: any) {
    return this.http.post(
      `${this.basePath}${this.pdfdocument}`,
      { data },
      { ...this.options, ...{ responseType: 'blob' } },
    );
  }

  actionDates(data: any) {
    return this.http.post(
      `${this.basePath}${this.actiondates}`,
      { data },
      this.options,
    );
  }

  editAnswers(data: any) {
    return this.http.put(
      `${this.basePath}${this.editanswers}`,
      { data },
      this.options,
    );
  }

  // main master
  addframeworks(data: any) {
    return this.http.post(
      `${this.basePath}${this.frameworkadd}`,
      { data },
      this.options,
    );
  }

  editframeworl(data: any) {
    return this.http.put(
      `${this.basePath}${this.frameworkedit}`,
      { data },
      this.options,
    );
  }

  findbyid(data: any) {
    return this.http.post(
      `${this.basePath}${this.framwworkfindbyid}`,
      { data },
      this.options,
    );
  }

  Getallframework(data: any) {
    return this.http.post(
      `${this.basePath}${this.frameworkgetall}`,
      { data },
      this.options,
    );
  }

  Updatestatus(data: any) {
    return this.http.put(
      `${this.basePath}${this.frameworkstaupdate}`,
      { data },
      this.options,
    );
  }

  Activestatus(data: any) {
    return this.http.post(
      `${this.basePath}${this.frameworkstaupdate}`,
      { data },
      this.options,
    );
  }

  // MOM
  addFirstForm(data: any) {
    return this.http.post(
      `${this.basePath}${this.addfirstform}`,
      { data },
      this.options,
    );
  }

  addSecondForm(data: any) {
    return this.http.post(
      `${this.basePath}${this.addsecondform}`,
      { data },
      this.options,
    );
  }

  addThirdForm(data: any) {
    return this.http.post(
      `${this.basePath}${this.addthirdform}`,
      { data },
      this.options,
    );
  }

  getAllMom(data: any) {
    return this.http.post(
      `${this.basePath}${this.getallmom}`,
      { data },
      this.options,
    );
  }

  getMomById(data: any) {
    return this.http.post(
      `${this.basePath}${this.getmombyid}`,
      { data },
      this.options,
    );
  }

  getMomEmployees(data: any) {
    return this.http.post(
      `${this.basePath}${this.getmomemployees}`,
      { data },
      this.options,
    );
  }

  updateMom(data: any) {
    return this.http.put(
      `${this.basePath}${this.updatemom}`,
      { data },
      this.options,
    );
  }

  approveMom(data: any) {
    return this.http.put(
      `${this.basePath}${this.approvemom}`,
      { data },
      this.options,
    );
  }

  ackMom(data: any) {
    return this.http.put(
      `${this.basePath}${this.ackmom}`,
      { data },
      this.options,
    );
  }

  viewMomHistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewmomhistory}`,
      { data },
      this.options,
    );
  }

  viewMomHistoryById(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewmomhistorybyid}`,
      { data },
      this.options,
    );
  }

  momActionDates(data: any) {
    return this.http.post(
      `${this.basePath}${this.momactiondates}`,
      { data },
      this.options,
    );
  }

 
    // Agreement Contract

    Addagreementcontract(formdata: FormData) {
        return this.http.post(`${this.basePath}${this.addagreentcont}`, formdata, this.optionsMultipart)
    }

    Editagreementcontract(formdata: FormData) {
        return this.http.put(`${this.basePath}${this.editagreemtcont}`, formdata, this.optionsMultipart)
    }

    Getallagreementcontract(data: any) {
        return this.http.post(`${this.basePath}${this.getallagreement}`, { data }, this.options)
    }

    agreementbyId(data: any) {
        return this.http.post(`${this.basePath}${this.getbyidagreement}`, { data }, this.options)
    }

    Agreementhistory(data: any) {
        return this.http.post(`${this.basePath}${this.agrementhistoryview}`, { data }, this.options)
    }

    filepasswordverify(data: any) {
        return this.http.post(`${this.basePath}${this.passwordvirify}`, { data }, this.options)
    }

    Documentview(data: any) {
        return this.http.post(`${this.basePath}${this.viewdocument}`, { data }, { ...this.options, ...{ responseType: 'blob' } })
    }

    Historypasswordverify(data: any) {
        return this.http.post(`${this.basePath}${this.historypassword}`, { data }, this.options)
    }

    Historyfileverification(data: any) {
        return this.http.post(`${this.basePath}${this.historyfileverify}`, { data }, { ...this.options, ...{ responseType: 'blob' } })
    }

    UpdatepasswordRequest(data: any) {
        return this.http.post(`${this.basePath}${this.updaterequestpassword}`,{data},this.options);
    }

    Sendotpforagreement(data: any){
        return this.skiploader.post(`${this.basePath}${this.sendotpforagreement}`,{data},this.Passwordtoken)
    }

    Verifyotpfoeagreement(data: any){
        return this.skiploader.post(`${this.basePath}${this.verifyotpforagreement}`,{data},this.Passwordtoken)
    }

    Resendpasswordforagreement(data: any){
        return this.skiploader.post(`${this.basePath}${this.resendpasswordforagreement}`,{data},this.Passwordtoken)
    }

    Viewbylinkid(data: any){
        return this.skiploader.post(`${this.basePath}${this.linkbyid}`,{data},this.Passwordtoken)
    }
 
    
 

  // Conference Reference
  addReference(data: any) {
    return this.http.post(
      `${this.basePath}${this.addreference}`,
      { data },
      this.options,
    );
  }

  referenceStatus(data: any) {
    return this.http.put(
      `${this.basePath}${this.referencestatus}`,
      { data },
      this.options,
    );
  }

  editReference(data: any) {
    return this.http.put(
      `${this.basePath}${this.editreference}`,
      { data },
      this.options,
    );
  }

  getAllReference(data: any) {
    return this.http.post(`${this.basePath}${this.getallreference}`,{data},this.options)
    // return this.http.post(
    //   this.adminURL(this.getallreference),
    //   { data },
    //   this.options,
    // );
  }

  // Audit Result
    addAuditResult(data: any) {
    return this.http.post(
      `${this.basePath}${this.addauditresult}`,
      { data },
      this.options,
    );
  }

      editAuditResult(data: any) {
    return this.http.put(
      `${this.basePath}${this.editauditresult}`,
      { data },
      this.options,
    );
  }

      addAuditControl(data: FormData) {
    return this.http.post(
      `${this.basePath}${this.addauditcontrol}`,
       data ,
      this.optionsMultipart,
    );
  }

  
      getAuditResult(data: any) {
    return this.http.post(
      `${this.basePath}${this.getauditresult}`,
       {data} ,
      this.options,
    );
  }

   getEmployeeByDepartment(data: any) {
    return this.http.post(
      `${this.basePath}${this.getemployeebydepartment}`,
       {data} ,
      this.options,
    );
  }

  getAuditControl(data: any) {
    return this.http.post(
      `${this.basePath}${this.getauditcontrol}`,
       {data} ,
      this.options,
    );
  }

    editAuditControl(data: FormData) {
    return this.http.put(
      `${this.basePath}${this.editauditcontrol}`,
       data ,
          this.optionsMultipart,

    );
  }

   addCorrective(data: FormData) {
    return this.http.post(
      `${this.basePath}${this.addcorrective}`,
       data ,
          this.optionsMultipart,

    );
  }

   editCorrective(data: FormData) {
    return this.http.put(
      `${this.basePath}${this.editcorrective}`,
       data ,
          this.optionsMultipart,

    );
  }

  auditReview(data: any) {
    return this.http.put(
      `${this.basePath}${this.auditreview}`,
      { data },
      this.options,
    );
  }

  auditApprove(data: any) {
    return this.http.put(
      `${this.basePath}${this.auditapprove}`,
      { data },
      this.options,
    );
  }

   getCorrectiveDatas(data: any) {
    return this.http.post(
      `${this.basePath}${this.getcorrectivedatas}`,
      { data },
      this.options,
    );
  }

     viewAuditControlDoc(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewauditcontroldoc}`,
      { data },
      {...this.optionsMultipart,
        ... {responseType:'blob'}
      }
    );
  }

    viewAuditControlHistoryDoc(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewauditcontrolhistorydoc}`,
      { data },
      {...this.optionsMultipart,
        ... {responseType:'blob'}
      }
    );
  }

   viewSupportDoc(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewsupportdoc}`,
      { data },
      {...this.optionsMultipart,
        ... {responseType:'blob'}
      }
    );
  }

     viewSupportDocHistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewsupportdochistory}`,
      { data },
      {...this.optionsMultipart,
        ... {responseType:'blob'}
      }
    );
  }
    viewAuditResultHistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewauditresulthistory}`,
      { data },
      this.options,
    );
  }

    viewAuditControlActions(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewauditcontrolactions}`,
      { data },
      this.options,
    );
  }

   viewAuditControlHistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewauditcontrolhistory}`,
      { data },
      this.options,
    );
  }
  viewCorrectiveHistory(data: any) {
    return this.http.post(
      `${this.basePath}${this.viewcorrectivehistory}`,
      { data },
      this.options,
    );
  }


   
    
    // mainmaster Equipment Creation

    Createequipment(data: any) {
        return this.http.post(`${this.basePath}${this.equipmentcreation}`, { data }, this.options)
    }

    Updateequipment(data: any) {
        return this.http.put(`${this.basePath}${this.equipmentupdate}`, { data }, this.options)
    }

    Viewallequipment(data: any) {
        return this.http.post(`${this.basePath}${this.equipmentviewall}`, { data }, this.options)
    }

    Updatestatusforequipment(data: any) {
        return this.http.put(`${this.basePath}${this.equipmentupdatestatus}`, { data }, this.options)
    }

    Getbyidforequipment(data: any) {
        return this.http.post(`${this.basePath}${this.equipmentgetbuid}`, { data }, this.options)
    }
 
 

    // Equipment AMCs

    createquipmentAMCs(formdata: FormData) {
        return this.http.post(`${this.basePath}${this.AMCscreation}`, formdata, this.optionsMultipart)
    }

    UpdateequipmentAMCs(formdata: FormData) {
        return this.http.put(`${this.basePath}${this.AMCsupdate}`, formdata, this.optionsMultipart)
    }

    ViewallequipmentAMCs(data: any) {
        return this.http.post(`${this.basePath}${this.AMCsviewall}`, { data }, this.options)
    }

    Findbuidequipment(data: any) {
        return this.http.post(`${this.basePath}${this.AMCsfindbyid}`, { data }, this.options)
    }

    DocumentvieequipmentAMCs(data: any) {
        return this.http.post(`${this.basePath}${this.AMCsviewdocument}`, { data }, this.options)
    }

    Equipmentdocview(data: any) {
        return this.http.post(`${this.basePath}${this.AMCsviewreport}`, { data }, { ...this.options, ...{ responseType: 'blob' } })
    }

    Equipmenthistorydocview(data: any) {
        return this.http.post(`${this.basePath}${this.historydocview}`, { data }, { ...this.options, ...{ responseType: 'blob' } })
    }

    Equipmenthistoryview(data: any) {
        return this.http.post(`${this.basePath}${this.historyviewAMCs}`, { data }, this.options)
    }

    Equipmenthistorybuid(data: any) {
        return this.http.post(`${this.basePath}${this.historyfindbuid}`, { data }, this.options)
    }



    // Tyche-complaines password
    
    Tychecomplainesviewbulinkid(data: any){
        return this.skiploader.post(`${this.basePath}${this.viewbylinkidforTychecom}`,{data},this.Passwordtoken)
    }

    Tychecomplainessendrequest(data: any){
        return this.skiploader.post(`${this.basePath}${this.sendrequestfortychecom}`,{data},this.Passwordtoken)
    }

    Tychecomplainessendotp(data: any){
        return this.skiploader.post(`${this.basePath}${this.sendotpfortychecom}`,{data},this.Passwordtoken)
    }

    Tychecomplainesverifypassword(data: any){
        return this.skiploader.post(`${this.basePath}${this.verifyotpfortychecom}`,{data},this.Passwordtoken)
    }

    Tychecomplainesresetpassword(data: any){
        return this.skiploader.post(`${this.basePath}${this.resetpasswordfortychecom}`,{data},this.Passwordtoken)
    }

    // Vendor complaines update password

    Vendorcomplainesviewlivkbyid(data: any){
        return this.skiploader.post(`${this.basePath}${this.viewbylinkidforvendor}`,{data},this.Passwordtoken)
    }

    Vendorcomplainessendrequest(data: any){
        return this.skiploader.post(`${this.basePath}${this.sendrequestforvendor}`,{data},this.Passwordtoken)
    }

    Vendorcomplainessendotp(data: any){
        return this.skiploader.post(`${this.basePath}${this.sendotpforvendor}`,{data},this.Passwordtoken)
    }

    Vendorcomplainesverifyotp(data: any){
        return this.skiploader.post(`${this.basePath}${this.verifyotpforvendor}`,{data},this.Passwordtoken)
    }

    Vendorcomplainesresetotp(data: any){
        return this.skiploader.post(`${this.basePath}${this.resetpasswordforvendor}`,{data},this.Passwordtoken)
    }

    // Board resolution update password

    Boardresolutionviewbylinkid(data: any){
        return this.skiploader.post(`${this.basePath}${this.viewbylinkidforboard}`,{data},this.Passwordtoken)
    }

    Boardresolutionsendrequest(data: any){
        return this.skiploader.post(`${this.basePath}${this.sendrequestforboard}`,{data},this.Passwordtoken)
    }

    Boardresolutionsendotp(data: any){
        return this.skiploader.post(`${this.basePath}${this.sendotpforboard}`,{data},this.Passwordtoken)
    }

    Boardresolutionverifyotp(data: any){
        return this.skiploader.post(`${this.basePath}${this.verifyotpforboard}`,{data},this.Passwordtoken)
    }

    Boardresolutionresetpassword(data: any){
        return this.skiploader.post(`${this.basePath}${this.resetpasswordforboard}`,{data},this.Passwordtoken)
    }

 


 
 
}
